import _regeneratorRuntime from "/data/maven/.jenkins/workspace/web/web/node_modules/@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { rinkoApplicationSubmit, rinkoImageUploads, rinkoImageView, rinkoImageDel, rinkoApplicationCheck, rinkoLastYearPayAmount } from '@/api/rinko';
import { queryAll, codeTypeList, getPath_biaodi, excleCargoDownload_biaodi, queryCountry, newShipInformation } from '@/api/policymanagement';
import { num4_type_fun, num5_type_fun, toThousands, _type_fun, accAdd, num3_type_fun, deepcopy, unique } from '../../libs/common';
import { getChilComList, getProductList, getCompanyList, getKindInfoList, getClauseList, getClauseListByType // getProtocolItemList,
, queryliPeiData, getBaseDateList, getProvinceCityArea } from '@/api/baseDate';
import { getCountryList, getCityList, getUnderCity, getCHNCity } from '@/utils/country';
import currencyInput from '@/components/v-currencyInput/CurrencyInput';
import $ from 'jquery';
import XLSX from 'xlsx';
export default {
  name: 'InsuranceApplyFor',
  components: {
    currencyInput: currencyInput
  },
  data: function data() {
    var _this = this;

    var checkAge = function checkAge(rule, value, callback) {
      var regu = /^(\-\d+)?$/;
      var ragu = /^([1-9]\d*|0)(\.\d{1,2})?$/;

      if (regu.test(value) == true) {
        return callback(new Error('请输入正数'));
      } else if (ragu.test(value) == false) {
        // return callback(new Error('请输入两位小数'))
        return callback();
      } else {
        return callback();
      }
    };

    var checkBge = function checkBge(rule, value, callback) {
      var regu = /^(\-\d+)?$/;
      var ragu = /^([1-9]\d*|0)(\.\d{1,2})?$/;
      var resg = /^\d+$|^\d*\.\d+$/g;

      if (!value) {
        return callback(new Error('请输入数量'));
      } else if (regu.test(value) == true) {
        return callback(new Error('请输入正数'));
      } else if (ragu.test(value) == false) {
        // return callback(new Error('请输入两位小数'))
        return callback();
      } else {
        return callback();
      }
    };

    var checkCge = function checkCge(rule, value, callback) {
      var regu = /^(\-\d+)?$/;
      var ragu = /^([1-9]\d*|0)(\.\d{1,2})?$/;

      if (!value) {
        return callback(new Error('请输入总价'));
      } else if (regu.test(value) == true) {
        return callback(new Error('请输入正数'));
      } else if (ragu.test(value) == false) {
        // return callback(new Error('请输入两位小数'))
        return callback();
      } else {
        return callback();
      }
    };

    return {
      // 保险禁用标识符
      wYtFalg: false,
      // 保险模块的显示和隐藏
      imageShowFlag: true,
      dialogFormVisible2: false,
      imageDisabledFlag: false,
      cargoDisabledFlag: false,
      dialogFormVisible1: false,
      fileList_exlc: [],
      country_option: [],
      packTypes_option: [{
        value: '0',
        label: '否'
      }, {
        value: '1',
        label: '是'
      }],
      city_option1: [],
      tableData_ship: [],
      select_radio_s_obj: {},
      ship_index: '',
      radio2: null,
      label_s2: '',
      city_option2: [],
      shipClass_option: [],
      shipTypes_option: [],
      itemType_option2: [],
      isneworold_option: [],
      measuringUnit_option: [],
      itemType_option: [],
      conveyance_option: [],
      tradeTerms_option: [],
      packType_option: [],
      currency_option: [],
      dialogFormVisible3: false,
      matter_flag: '',
      matter_index: '',
      decimalValue: 2,
      decimalValue2: 2,
      decimalValue3: 3,
      decimalValue6: 6,
      text4: {
        conveyanceWayCode: '',
        clinchWayCode: '',
        conveyanceCode: '',
        freightCurrency: '',
        blName: '',
        voyageNo: '',
        startTime: '',
        startSiteCountryCode: '',
        viaSiteCountryCode: '',
        endSiteCountryCode: '',
        checkAgentCode: '',
        vessel: '',
        shipClassCode: '',
        shipTypesCode: '',
        freight: ''
      },
      proposalItemCargoDto_obj: {
        itemCode: '',
        itemType: '',
        itemTypeName: '',
        cargoName: '',
        cargoEnName: '',
        quantity: '',
        isNewOrOld: '',
        unit: '',
        unitName: '',
        unitAmount: '0',
        totalAmount: '0',
        cargoCodeName: ''
      },
      cityShowFlag: true,
      cityDisabledFlag: false,
      provinceList: [],
      cityList: [],
      areaList: [],
      allAddressData: [],
      proposalItemCargoDto_obj_rules: {
        itemType: [{
          required: true,
          message: '请选择标的类型',
          trigger: 'change'
        }],
        quantity: [{
          required: true,
          trigger: 'blur',
          validator: checkBge
        }],
        isNewOrOld: [{
          required: true,
          message: '请选择货物新旧标识',
          trigger: 'change'
        }],
        unit: [{
          required: true,
          message: '请选择单位',
          trigger: 'change'
        }],
        unitAmount: [{
          required: false,
          trigger: 'blur',
          validator: checkAge
        }],
        totalAmount: [{
          required: true,
          // message: '请输入总价',
          trigger: 'blur',
          // 当失去焦点就进行一次验证
          validator: checkCge // 当失去焦点，会使validator验证,会调用一次checkAge函数。并且会给checkAge默认传参数，checkAge(rules,value,callback){}，value是input框中的内容，callback是回调函数。这3个参数是关键，必须要传给vuex store中的验证函数。

        }]
      },
      // 产品生产责任的校验
      lprlItemListRules: {
        // 产品名称
        itemName: {
          required: true,
          message: '请输入产品名称',
          trigger: 'blur'
        },
        // 币种名称
        currencyName: {
          required: true,
          message: '请输入币种名称',
          trigger: 'blur'
        },
        // 销售额
        salesVolume: _defineProperty({
          required: true,
          message: '请输入销售额',
          trigger: 'blur',
          pattern: /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/
        }, "message", '请输入数字,可保留两位小数'),
        // 产品代码
        itemCode: {
          required: true,
          message: '请输入产品代码',
          trigger: 'blur'
        },
        // 年销售数量
        annualSalesNum: _defineProperty({
          required: true,
          message: '请输入年销售数量',
          trigger: 'blur',
          pattern: /(^(0|[1-9][0-9]*)$)/
        }, "message", '请输入整数!'),
        // 销售国家和地区
        saleCountryArea: {
          required: true,
          message: '请输入销售国家和地区',
          trigger: 'blur'
        },
        // 币种
        currency: {
          required: true,
          message: '请输入币种',
          trigger: 'blur'
        }
      },
      // 财产一切险的校验
      fpapItemListRules: {
        // 承保标的项目
        underWriteItemProject: {
          required: true,
          message: '请输入承保标的项目',
          trigger: 'blur'
        },
        // 保险金额
        insuranceAmount: _defineProperty({
          required: true,
          message: '请输入保险金额',
          trigger: 'blur',
          pattern: /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/
        }, "message", '请输入数字,可保留两位小数'),
        // 币种
        currency: {
          required: true,
          message: '请输入产品名称',
          trigger: 'blur'
        },
        // 保险金额确认方式
        amountConfirmWay: {
          required: true,
          message: '请输入产品名称',
          trigger: 'blur'
        }
      },
      // 2022年8月19日 王宇通
      isSave: false,
      // 是否暂存
      isViewType: false,
      // 投保申请基本信息置灰状态
      isViewUploadGoods: true,
      // 投保申请基本信息置灰状态
      taxAmountSumFlag: false,
      // 过往一年关税缴纳总额  如果调用亿通接口返回的有数据，则不再允许修改了
      isView: false,
      isList1: false,
      isList7: false,
      fileList: [],
      fileList1: [],
      fileList2: [],
      fileList3: [],
      fileList4: [],
      fileList5: [],
      fileList6: [],
      fileList7: [],
      upimgsNum: 0,
      isUpimg: false,
      fileListZ: [],
      fileListF: {
        imagUse: '',
        imagUseType: '',
        name: '',
        imagUseName: ''
      },
      dialogImageUrl: '',
      activeName: '',
      textarea: "请您如实填写相关投保信息，此内容将影响保险公司的承保和理赔结果。本平台及保险公司对您提供的信息及资料承担保密义务，我们将采取恰当的物理、电子、管理技术手段保护投保人提供的资料，同时，采取适当的安全措施保护投保人提供的资料免于未经授权的访问、使用或泄露。请您仔细阅读保险产品简介，保险公司业务人员将向您进行进一步的说明，并向您出具投保单。",
      uploadOptions1: [{
        title: '项目总包合同'
      }],
      uploadOptions: [{
        title: '企业营业执照，法人身份证'
      }, {
        title: '过往两年审计报告'
      }, {
        title: '近期盖章财报'
      }, {
        title: '近1月内企业征信报告'
      }, {
        title: '报价申请表'
      }, {
        title: '近调人气合照'
      }],
      tabList: [],
      tabList2: [],
      checkOptions: [],
      tableData: [{
        date: '',
        name: '',
        checkOptions: [],
        address: ''
      }, {
        date: '2016-05-04',
        name: '',
        checkOptions: [],
        address: ''
      }],
      tableData3: [{
        date: '',
        name: '',
        checkOptions: [],
        address: ''
      }, {
        date: '2016-05-04',
        name: '',
        checkOptions: [],
        address: ''
      }],
      tableData2: [{
        date: '2016-05-04',
        name: '',
        checkOptions: [],
        address: ''
      }],
      checkList: [{
        label: '人身意外伤害保险',
        code: '1'
      }, {
        label: '出口产品责任保险',
        code: '2'
      }, {
        label: '关税保证保险',
        code: '3'
      }, {
        label: '货物运输保险',
        code: '4'
      }, {
        label: '企业财产保险',
        code: '5'
      }, {
        label: '安全生产责任保险',
        code: '6'
      }, {
        label: '出口贸易信用保险（短期）',
        code: '7'
      }],
      insureIntentionFlag: false,
      // 省市区显示flag
      pcaShowFlag: true,
      pcaDisabledFlag: false,
      delAddShowFlag: true,
      //删除 增加按钮是否显示flag
      // 表单 Form
      fpapItemList1: [{
        // 险别名称
        riskName: '',
        // 承保标的项目
        underWriteItemProject: '',
        // 保险金额
        insuranceAmount: '',
        // 币种中文名称
        currencyName: '',
        // 标的用途 1、保险标的 2、特约保险标的 3、附加险标的
        itemUseType: '1',
        // 投保单意向申请号
        applicationNo: '',
        // 险别代码
        riskCode: '',
        // 币种
        currency: '',
        // 保险金额确认方式
        amountConfirmWay: '',
        // 序号
        serialNo: 1
      }],
      fpapItemList2: [{
        // 险别名称
        riskName: '',
        // 承保标的项目
        underWriteItemProject: '',
        // 保险金额
        insuranceAmount: '',
        // 币种中文名称
        currencyName: '',
        // 标的用途 1、保险标的 2、特约保险标的 3、附加险标的
        itemUseType: '2',
        // 投保单意向申请号
        applicationNo: '',
        // 险别代码
        riskCode: '',
        // 币种
        currency: '',
        // 保险金额确认方式
        amountConfirmWay: '',
        // 序号
        serialNo: 1
      }],
      fpapItemList3: [{
        // 险别名称
        riskName: '',
        // 承保标的项目
        underWriteItemProject: '',
        // 保险金额
        insuranceAmount: '',
        // 币种中文名称
        currencyName: '',
        // 标的用途 1、保险标的 2、特约保险标的 3、附加险标的
        itemUseType: '3',
        // 投保单意向申请号
        applicationNo: '',
        // 险别代码
        riskCode: '',
        // 币种
        currency: '',
        // 保险金额确认方式
        amountConfirmWay: '',
        // 序号
        serialNo: 1
      }],
      shipFlag: false,
      ruleForm: {
        applicationNo: '',
        shipInvokeFlag: '',
        insuranceCompanyCode: '',
        insuranceCompanyName: '',
        // 初入页面的基础信息
        basicInfo: {
          customCompanyName: '',
          linkmanDeptCode: '',
          linkmanEmail: '',
          linkmanName: '',
          insureIntention: [],
          linkmanDeptName: '',
          linkmanPhone: '',
          insureIntentionStr: ''
        },
        // 团体人身意外伤害保险
        productAgap: {
          // 附加险每人保险金额
          additionRiskInsureAmount: '',
          // 主险
          mainRisk: '',
          // 附加险
          additionRisk: '',
          // 主险每人保险金额
          mainRiskInsureAmount: '',
          // 行业
          industry: '',
          // 工种
          typeWork: '',
          // 保险期间止期
          insuranceEndDate: '',
          // 保险期间起期
          insuranceStartDate: '',
          // 保险人数
          insureNumber: ''
        },
        // 财产一切险
        productFpap: {
          // 市
          cityCode: '',
          // 省
          provinceCode: '',
          // 邮箱编码
          postalCode: '',
          // 营业性质
          businessNature: '',
          // 特约保险金额小计
          engageInsuranceSum: '',
          // 保险表的表:保险
          fpapItemList: [],
          fpapItemList1: [{
            // 险别名称
            riskName: '',
            // 承保标的项目
            underWriteItemProject: '',
            // 保险金额
            insuranceAmount: '',
            // 币种中文名称
            currencyName: '',
            // 标的用途 1、保险标的 2、特约保险标的 3、附加险标的
            itemUseType: '1',
            // 投保单意向申请号
            applicationNo: '',
            // 险别代码
            riskCode: '',
            // 币种
            currency: '',
            // 保险金额确认方式
            amountConfirmWay: '',
            // 序号
            serialNo: 1
          }],
          //保险表的表：特约保险
          fpapItemList2: [{
            // 险别名称
            riskName: '',
            // 承保标的项目
            underWriteItemProject: '',
            // 保险金额
            insuranceAmount: '',
            // 币种中文名称
            currencyName: '',
            // 标的用途 1、保险标的 2、特约保险标的 3、附加险标的
            itemUseType: '2',
            // 投保单意向申请号
            applicationNo: '',
            // 险别代码
            riskCode: '',
            // 币种
            currency: '',
            // 保险金额确认方式
            amountConfirmWay: '',
            // 序号
            serialNo: 1
          }],
          //保险表的表：附加险
          fpapItemList3: [{
            // 险别名称
            riskName: '',
            // 承保标的项目
            underWriteItemProject: '',
            // 保险金额
            insuranceAmount: '',
            // 币种中文名称
            currencyName: '',
            // 标的用途 1、保险标的 2、特约保险标的 3、附加险标的
            itemUseType: '3',
            // 投保单意向申请号
            applicationNo: '',
            // 险别代码
            riskCode: '',
            // 币种
            currency: '',
            // 保险金额确认方式
            amountConfirmWay: '',
            // 序号
            serialNo: 1
          }],
          // 保险期间止期
          insuranceEndDate: '',
          // 保险标的金额小计
          insuranceSum: '',
          // 区
          areaCode: '',
          // 总保险金额
          totalInsuranceAmount: '',
          // 市名称
          cityName: '',
          // 区名称
          areaName: '',
          // 详细地址
          detailAddress: '',
          // 省名称
          provinceName: '',
          // 保险期间起期
          insuranceStartDate: '',
          //
          insureNumber: ''
        },
        // 产品责任保险
        productLprl: {
          // 每次事故人身伤害赔偿限额
          deadCompLimitAmount: '',
          // 以往是否出险
          isInDangerPrevious: '',
          // 累计赔偿限额
          totalCompLimitAmount: '',
          // 每次事故财产损失赔偿限额
          lossCompLimitAmount: '',
          // 标识符
          validationFlag: '',
          // 保险期间止期
          insuranceEndDate: '',
          // 产品最初生产日期
          productGenerateDate: '',
          // 产品责任保险 产品信息
          lprlItemList: [{
            // 产品名称
            itemName: '',
            // 币种名称
            currencyName: '',
            // 销售额
            salesVolume: '',
            // 产品代码
            itemCode: '',
            // 年销售数量
            annualSalesNum: '',
            // 销售国家和地区
            saleCountryArea: '',
            // 币种
            currency: '',
            // 序号
            serialNo: 1
          }],
          // 保险期间起期
          insuranceStartDate: '',
          // 销售额总计
          saleSumAmount: '',
          // 以往是否投保
          isInsurePrevious: '',
          // 每次事故赔偿限额
          compLimitAmount: '',
          // 每次事故每人赔偿限额
          everyCompLimitAmount: ''
        },
        // 安全生产责任保险
        productSpdp: {
          // 是否已开工
          isOnWork: '',
          // 报建编号
          constructNo: '',
          // 保险公司代码
          insuranceCompanyCode: '',
          // 保险期间止期
          insuranceEndDate: '',
          // 保险期间起期
          insuranceStartDate: '',
          // 工程名称
          projectName: '',
          // 贡献公司名称
          insuranceCompanyName: ''
        },
        // 关税保证保险
        productCsbp: {
          // 保险金额
          amount: '',
          // 申报海关
          declareCustoms: '',
          // 关税保证保险单用途
          policyPurpose: '',
          // 法定代表人
          legalRepresent: '',
          // 过往一年关税缴纳金额
          lastYearPayAmount: '',
          // 企业海关注册编码
          customsRegisterCode: '',
          // 保险期间止
          insuranceEndDate: '',
          // 授权代理人
          authorizedAgent: '',
          // 是否短期投保 0 否 1 是
          isShortInsure: '',
          // 社会信用代码
          orgCode: '',
          // 注册海关
          registerCustoms: '',
          // 保险期间起
          insuranceStartDate: '',
          // 被保险人名称
          insuredName: '',
          // 海关信用等级
          customsCreditGrade: ''
        },
        // 货运险
        productCargo: {
          //
          productCargoConveyItem: {
            //
            storagePeriod: '',
            //
            termsOfTrade: '',
            //
            billCurrencyName: '',
            //
            customsListNo: '',
            //
            freight: '',
            //
            conveyanceWayCode: '',
            //
            isContainer: '',
            isRefrigeRate: '',
            remark: '',
            invoicNo: '',
            marks: '',
            insuranceCompanyCode: '',
            insuranceCompanyName: '',
            ladingNO: '',
            packingWay: '',
            billAmount: '',
            conveyanceWayName: '',
            freightCurrency: '',
            billCurrency: '',
            packingWayCode: '',
            freightCurrencyName: '',
            startTime: '',
            clinchWayName: '',
            clinchWayCode: '',
            policyNo: ''
          },
          cargoConveyList: [{
            conveyanceCode: '',
            shipTypes: '',
            startSiteCountryCode: '',
            flag: '',
            applicationNo: '',
            startSiteCityName: '',
            validationFlag: '',
            viaSiteCityCode: '',
            shipTypesCode: '',
            endSiteCityCode: '',
            startSiteCityCode: '',
            voyageNumber: 1,
            shipClassName: '',
            vessel: '',
            startSiteCountryName: '',
            voyageNo: '',
            viaSiteCityName: '',
            blName: '',
            endSiteCountryName: '',
            shipClassCode: '',
            conveyanceName: '',
            insuranceCompanyCode: '',
            endSiteCityName: '',
            insuranceCompanyName: '',
            viaSiteCountryName: '',
            viaSiteCountryCode: '',
            endSiteCountryCode: ''
          }],
          cargoItemList: [// {
            //   itemType: '',
            //   isNewOrOld: "1",
            //   quantity: '',
            //   unitName: '',
            //   applicationNo: '',
            //   itemCode: '',
            //   validationFlag: '',
            //   cargoEnName: '',
            //   serialNo: 1,
            //   totalAmount: '',
            //   unit: '',
            //   cargoName: '',
            //   unitAmount: '',
            //   itemTypeName: ''
            // }
          ]
        },
        // 贸易信用保险
        productTcrp: {
          // 付款条件
          payCondition: '',
          // 过去12个月年赊销售额（人民币 千元）
          lastYearSalesAmount: '',
          // 预计未来一年赊销售额（人民币 千元）
          predictYearSalesAmount: '',
          // 历史交易年限
          historyTradeAgeLimit: '',
          // 付款条件名称
          payConditionName: '',
          // 申请信用额度（人民币 千元）
          applyCreditQuota: '',
          // 是否有单标（如有 请提供担保方的公司中文全称）
          isWarrant: '',
          // 买方公司中文名称
          buyerCompanyName: '',
          // 保险公司代码
          insuranceCompanyCode: '',
          // 保险期间止期
          insuranceEndDate: '',
          // 保险公司名称
          insuranceCompanyName: '',
          // 工商局公司注册号
          tibRegisterNo: '',
          // 保险期间起期
          insuranceStartDate: ''
        },
        //
        lastTreYearBus: [{
          flag: '1',
          riskName: '主险',
          everyAmount: ''
        }, {
          flag: '2',
          riskName: '附加险',
          everyAmount: ''
        }],
        companyName: '',
        linkmanName: '',
        linkmanNo: '',
        initCreateDate: '',
        amout: '',
        linkmanEmial: '',
        isCX: '1',
        isTB: '1',
        linkmanPart: '',
        trade: '',
        work: '',
        person: '',
        // 开始日期
        date1: '',
        // 结束日期
        date2: '',
        delivery: false,
        type: [],
        resource: '',
        desc: ''
      },
      // 起止时间的校验
      dateTimeStartFunc1: {
        disabledDate: function disabledDate(time) {
          if (_this.ruleForm.productAgap.insuranceEndDate) {
            return time.getTime() > new Date(_this.ruleForm.productAgap.insuranceEndDate).getTime();
          }
        }
      },
      dateTimeEndFunc1: {
        disabledDate: function disabledDate(time) {
          if (_this.ruleForm.productAgap.insuranceStartDate) {
            return time.getTime() < new Date(_this.ruleForm.productAgap.insuranceStartDate).getTime() - 8.64e7;
          }
        }
      },
      dateTimeStartFunc2: {
        disabledDate: function disabledDate(time) {
          if (_this.ruleForm.productLprl.insuranceEndDate) {
            return time.getTime() > new Date(_this.ruleForm.productLprl.insuranceEndDate).getTime();
          }
        }
      },
      dateTimeEndFunc2: {
        disabledDate: function disabledDate(time) {
          if (_this.ruleForm.productLprl.insuranceStartDate) {
            return time.getTime() < new Date(_this.ruleForm.productLprl.insuranceStartDate).getTime() - 8.64e7;
          }
        }
      },
      dateTimeStartFunc3: {
        disabledDate: function disabledDate(time) {
          if (_this.ruleForm.productCsbp.insuranceEndDate) {
            return time.getTime() > new Date(_this.ruleForm.productCsbp.insuranceEndDate).getTime();
          }
        }
      },
      dateTimeEndFunc3: {
        disabledDate: function disabledDate(time) {
          if (_this.ruleForm.productCsbp.insuranceStartDate) {
            return time.getTime() < new Date(_this.ruleForm.productCsbp.insuranceStartDate).getTime() - 8.64e7;
          }
        }
      },
      dateTimeStartFunc5: {
        disabledDate: function disabledDate(time) {
          if (_this.ruleForm.productFpap.insuranceEndDate) {
            return time.getTime() > new Date(_this.ruleForm.productFpap.insuranceEndDate).getTime();
          }
        }
      },
      dateTimeEndFunc5: {
        disabledDate: function disabledDate(time) {
          if (_this.ruleForm.productFpap.insuranceStartDate) {
            return time.getTime() < new Date(_this.ruleForm.productFpap.insuranceStartDate).getTime() - 8.64e7;
          }
        }
      },
      dateTimeStartFunc6: {
        disabledDate: function disabledDate(time) {
          if (_this.ruleForm.productSpdp.insuranceEndDate) {
            return time.getTime() > new Date(_this.ruleForm.productSpdp.insuranceEndDate).getTime();
          }
        }
      },
      dateTimeEndFunc6: {
        disabledDate: function disabledDate(time) {
          if (_this.ruleForm.productSpdp.insuranceStartDate) {
            return time.getTime() < new Date(_this.ruleForm.productSpdp.insuranceStartDate).getTime() - 8.64e7;
          }
        }
      },
      dateTimeStartFunc7: {
        disabledDate: function disabledDate(time) {
          if (_this.ruleForm.productTcrp.insuranceEndDate) {
            return time.getTime() > new Date(_this.ruleForm.productTcrp.insuranceEndDate).getTime();
          }
        }
      },
      dateTimeEndFunc7: {
        disabledDate: function disabledDate(time) {
          if (_this.ruleForm.productTcrp.insuranceStartDate) {
            return time.getTime() < new Date(_this.ruleForm.productTcrp.insuranceStartDate).getTime() - 8.64e7;
          }
        }
      },
      rules: {
        mainRiskInsureAmount: [{
          pattern: /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/,
          message: '请输入数字,可保留两位小数'
        }],
        additionRiskInsureAmount: [{
          pattern: /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/,
          message: '请输入数字,可保留两位小数'
        }],
        conveyanceWayCode: [{
          required: true,
          message: '请选择运输条件',
          trigger: 'change'
        }],
        packingWayCode: [{
          required: true,
          message: '请选择包装方式',
          trigger: 'change'
        }],
        isContainer: [{
          required: true,
          message: '请选择是否集装箱',
          trigger: 'change'
        }],
        isRefrigeRate: [{
          required: true,
          message: '请选择是否冷藏',
          trigger: 'change'
        }],
        billCurrency: [{
          required: true,
          message: '请选择发票币种',
          trigger: 'change'
        }],
        startTime: [{
          required: true,
          message: '请选择起运日期',
          trigger: 'change'
        }],
        billAmount: [{
          required: true,
          message: '请输入发票金额',
          trigger: 'blur'
        }],
        provinceName: [{
          required: true,
          message: '请选择省',
          trigger: 'change'
        }],
        cityName: [{
          required: true,
          message: '请选择市',
          trigger: 'change'
        }],
        areaName: [{
          required: true,
          message: '请选择区',
          trigger: 'change'
        }],
        detailAddress: [{
          required: true,
          message: '请输入详细地址',
          trigger: 'blur'
        }],
        linkmanDeptName: [{
          required: true,
          message: '请输入联系人部门',
          trigger: 'blur'
        }],
        linkmanPhone: [{
          required: true,
          message: '请输入联系人号码',
          trigger: 'blur'
        }],
        linkmanEmail: [{
          required: true,
          message: '请输入联系人邮箱',
          trigger: 'blur'
        }, {
          pattern: /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/,
          message: '请输入正确的邮箱格式'
        }],
        insuranceEndDate: [{
          required: true,
          message: '请选择终止日期',
          trigger: 'change'
        }],
        insuranceStartDate: [{
          required: true,
          message: '请选择开始日期',
          trigger: 'change'
        }],
        customCompanyName: [{
          required: true,
          message: '请输入公司名称',
          trigger: 'blur'
        }],
        buyerCompanyName: [{
          required: true,
          message: '请输入买方公司中文全称',
          trigger: 'blur'
        }],
        tibRegisterNo: [{
          required: true,
          message: '请输入工商局公司注册号',
          trigger: 'blur'
        }],
        lastYearSalesAmount: [{
          required: true,
          message: '请输入过去12个月年赊销销售额',
          trigger: 'blur'
        }, {
          pattern: /(^[1-9]([0-9]+)?(\.[0-9]{1,5})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/,
          message: '请输入数字,可保留五位小数'
        }],
        predictYearSalesAmount: [{
          required: true,
          message: '请输入预计未来一年年赊销销售额',
          trigger: 'blur'
        }, {
          pattern: /(^[1-9]([0-9]+)?(\.[0-9]{1,5})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/,
          message: '请输入数字,可保留五位小数'
        }],
        applyCreditQuota: [{
          required: true,
          message: '请输入申请信用额度',
          trigger: 'blur'
        }, {
          pattern: /(^[1-9]([0-9]+)?(\.[0-9]{1,5})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/,
          message: '请输入数字,可保留五位小数'
        }],
        payConditionName: [{
          required: true,
          message: '请输入付款条件',
          trigger: 'blur'
        }],
        historyTradeAgeLimit: [{
          required: true,
          message: '请输入历史交易年限',
          trigger: 'blur'
        }],
        isWarrant: [{
          required: true,
          message: '请提供担保方公司中文名称',
          trigger: 'blur'
        }],
        isOnWork: [{
          required: true,
          message: '请选择是否开工',
          trigger: 'blur'
        }],
        projectName: [{
          required: true,
          message: '请输入工程名称',
          trigger: 'blur'
        }],
        constructNo: [{
          required: true,
          message: '请输入报建编号',
          trigger: 'blur'
        }],
        insuranceSum: [{
          required: true,
          message: '请输入保险金额小计',
          trigger: 'blur'
        }, {
          pattern: /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/,
          message: '请输入数字,可保留两位小数'
        }],
        engageInsuranceSum: [{
          required: true,
          message: '请输入保险金额小计',
          trigger: 'blur'
        }, {
          pattern: /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/,
          message: '请输入数字,可保留两位小数'
        }],
        totalInsuranceAmount: [{
          required: true,
          message: '请输入总保险金额',
          trigger: 'blur'
        }, {
          pattern: /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/,
          message: '请输入数字,可保留两位小数'
        }],
        postalCode: [{
          required: true,
          message: '请输入邮政编码',
          trigger: 'blur'
        }, {
          pattern: /(^[1-9]\d{5}$)/,
          message: '请输入正确格式'
        }],
        businessNature: [{
          required: true,
          message: '请输入营业性质',
          trigger: 'blur'
        }],
        provinceCode: [{
          required: true,
          message: '请选择省',
          trigger: 'blur'
        }],
        cityCode: [{
          required: true,
          message: '请选择市',
          trigger: 'blur'
        }],
        areaCode: [{
          required: true,
          message: '请选择区',
          trigger: 'blur'
        }],
        insuredName: [{
          required: true,
          message: '请输入被保险人名称（直属海关名称）',
          trigger: 'blur'
        }],
        registerCustoms: [{
          required: true,
          message: '请输入注册海关',
          trigger: 'blur'
        }],
        declareCustoms: [{
          required: true,
          message: '请输入申报海关',
          trigger: 'blur'
        }],
        amount: [{
          required: true,
          message: '请输入保险金额',
          trigger: 'blur'
        }, {
          pattern: /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/,
          message: '请输入数字,可保留两位小数'
        }],
        policyPurpose: [{
          required: true,
          message: '请输入关税保证保险单用途',
          trigger: 'blur'
        }],
        lastYearPayAmount: [{
          required: true,
          message: '请输入过往一年关税缴纳总额',
          trigger: 'blur'
        }, {
          pattern: /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/,
          message: '请输入数字,可保留两位小数'
        }],
        orgCode: [{
          required: true,
          message: '请输入统一社会信用代码证',
          trigger: 'change'
        }, {
          pattern: /^[^_IOZSVa-z\W]{2}\d{6}[^_IOZSVa-z\W]{10}$/g,
          message: '18位信用代码格式不正确'
        }],
        customsCreditGrade: [{
          required: true,
          message: '请输入海关信用等级',
          trigger: 'blur'
        }],
        customsRegisterCode: [{
          required: true,
          message: '请输入海关注册编码',
          trigger: 'blur'
        }],
        isShortInsure: [{
          required: true,
          message: '请选择是否短期投保',
          trigger: 'blur'
        }],
        productGenerateDate: [{
          required: true,
          message: '请选择最初生产日期',
          trigger: 'change'
        }],
        saleSumAmount: [{
          required: true,
          message: '请输入销售额总计',
          trigger: 'blur'
        }, {
          pattern: /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/,
          message: '请输入数字,可保留两位小数'
        }],
        isInsurePrevious: [{
          required: true,
          message: '请选择以往是否投保',
          trigger: 'blur'
        }],
        isInDangerPrevious: [{
          required: true,
          message: '请选择以往是否出险',
          trigger: 'blur'
        }],
        industry: [{
          required: true,
          message: '请输入行业',
          trigger: 'blur'
        }],
        typeWork: [{
          required: true,
          message: '请输入工种',
          trigger: 'blur'
        }],
        insureNumber: [{
          required: true,
          message: '请输入投保人数',
          trigger: 'blur'
        }, {
          pattern: /(^[0-9]*$)/,
          message: '请输入整数!'
        }],
        companyName: [{
          required: true,
          message: '请输入公司名称',
          trigger: 'blur'
        }, {
          min: 3,
          max: 5,
          message: '长度在 3 到 5 个字符',
          trigger: 'blur'
        }],
        linkmanName: [{
          required: true,
          message: '请输入联系人名称',
          trigger: 'blur'
        }],
        trade: [{
          required: true,
          message: '请输入行业',
          trigger: 'blur'
        }],
        work: [{
          required: true,
          message: '请输入工种',
          trigger: 'blur'
        }],
        initCreateDate: [{
          required: true,
          message: '请输入工种',
          trigger: 'blur'
        }],
        amout: [{
          required: true,
          message: '请输入工种',
          trigger: 'blur'
        }],
        personNum: [{
          required: true,
          message: '请输入投保人数',
          trigger: 'blur'
        }],
        linkmanNo: [{
          required: true,
          message: '请输入联系人号码',
          trigger: 'blur'
        }],
        linkmanEmial: [{
          required: true,
          message: '请输入联系人邮箱',
          trigger: 'blur'
        }],
        linkmanPart: [{
          required: true,
          message: '请输入联系人部门',
          trigger: 'blur'
        }],
        date1: [{
          type: 'date',
          required: true,
          message: '请选择日期',
          trigger: 'change'
        }],
        date2: [{
          type: 'date',
          required: true,
          message: '请选择时间',
          trigger: 'change'
        }],
        basicInfo: {
          insureIntention: [{
            type: 'array',
            required: true,
            message: '请至少选择一个投保意向',
            trigger: 'change'
          }]
        },
        resource: [{
          required: true,
          message: '请选择活动资源',
          trigger: 'change'
        }],
        desc: [{
          required: true,
          message: '请填写活动形式',
          trigger: 'blur'
        }]
      },
      tableArr: [{
        key: '每次赔偿限额',
        value: ''
      }, {
        key: '每次事故人身伤亡赔偿限额',
        value: ''
      }, {
        key: '每次事故每人赔偿限额',
        value: ''
      }, {
        key: '每次事故财产损失赔偿限额',
        value: ''
      }, {
        key: '累计赔偿限额',
        value: ''
      }],
      howWidth: 24
    };
  },
  watch: {
    'ruleForm.productFpap.fpapItemList1': {
      immediate: true,
      deep: true,
      handler: function handler(newValue, oldValue) {
        var sum = 0;

        for (var i = 0; i < newValue.length; i++) {
          if (newValue[i].insuranceAmount > 0) {
            sum += newValue[i].insuranceAmount;
          }
        }

        this.ruleForm.productFpap.insuranceSum = sum;
      }
    },
    'ruleForm.productFpap.fpapItemList2': {
      immediate: true,
      deep: true,
      handler: function handler(newValue, oldValue) {
        var sum = 0;

        for (var i = 0; i < newValue.length; i++) {
          if (newValue[i].insuranceAmount > 0) {
            sum += newValue[i].insuranceAmount;
          }
        }

        this.ruleForm.productFpap.engageInsuranceSum = sum;
      }
    },
    'ruleForm.productFpap.insuranceSum': {
      immediate: true,
      deep: true,
      handler: function handler(newValue, oldValue) {
        this.ruleForm.productFpap.totalInsuranceAmount = newValue + this.ruleForm.productFpap.engageInsuranceSum;
      }
    },
    'ruleForm.productFpap.engageInsuranceSum': {
      immediate: true,
      deep: true,
      handler: function handler(newValue, oldValue) {
        this.ruleForm.productFpap.totalInsuranceAmount = newValue + this.ruleForm.productFpap.insuranceSum;
      }
    },
    'ruleForm.productLprl.lprlItemList': {
      immediate: true,
      deep: true,
      handler: function handler(newValue, oldValue) {
        var sum = 0;

        for (var i = 0; i < newValue.length; i++) {
          if (newValue[i].annualSalesNum > 0 && newValue[i].salesVolume > 0) {
            sum += newValue[i].salesVolume;
          }
        }

        this.ruleForm.productLprl.saleSumAmount = sum;
      }
    },
    ProposalConveyanceDto: {
      // 运输信息
      handler: function handler(newValue, oldValue) {
        this.isSubmit_s = false;
        this.isSubmit_cont = false;
      },
      deep: true
    },
    ProposalItemDto: {
      handler: function handler(newValue, oldValue) {
        // 标的信息
        this.isSubmit_s = false;
        this.isSubmit_cont = false;
      },
      deep: true
    },
    'ProposalKindDto.amountCurrencyCode': {
      // 保额
      handler: function handler(newValue, oldValue) {
        this.isSubmit_s = false;
        this.isSubmit_cont = false;
      },
      deep: true
    },
    'ProposalKindDto.remiumCurrencyCode': {
      handler: function handler(newValue, oldValue) {
        // 保费
        this.isSubmit_s = false;
        this.isSubmit_cont = false;
      },
      deep: true
    }
  },
  mounted: function mounted() {
    this.proposalNo = this.$router.history.current.params.proposalNo;
    console.log('params==', this.proposalNo);
    var companyCode = this.$store.state.user.userinfo.insuranceCompanyCode || '';
    this.select_data(companyCode);
  },
  created: function created() {
    this.getAreaList();
    this.codeTypeList_fun();
    this.getProvinceCityData();
    this.codeTypeList_fun2();
    this.Init_get();
  },
  methods: {
    // 自定义校验
    //			数量
    quantity_ch: function quantity_ch(val) {
      //				console.log(val)
      //				console.log(this.proposalItemCargoDto_obj)
      if (val != "" && (this.proposalItemCargoDto_obj.unitAmount != "" || this.proposalItemCargoDto_obj.unitAmount != undefined)) {
        if (typeof val == "string") {
          val = parseFloat(val.replace(/,/g, "")).toFixed(6);
        } else {
          val = val.toFixed(6);
        }

        if (typeof this.proposalItemCargoDto_obj.unitAmount == "string") {
          this.proposalItemCargoDto_obj.unitAmount = parseFloat(this.proposalItemCargoDto_obj.unitAmount.replace(/,/g, "")).toFixed(6);
        } else {
          this.proposalItemCargoDto_obj.unitAmount = this.proposalItemCargoDto_obj.unitAmount.toFixed(6);
        }

        this.proposalItemCargoDto_obj.totalAmount = accMul(val, this.proposalItemCargoDto_obj.unitAmount);
      } else {
        this.proposalItemCargoDto_obj.totalAmount = "";
      }
    },
    //     单价
    unitAmount_ch: function unitAmount_ch(val) {
      this.proposalItemCargoDto_obj.quantity = '';

      if (val != "" && (this.proposalItemCargoDto_obj.quantity != "" || this.proposalItemCargoDto_obj.quantity != undefined)) {
        this.proposalItemCargoDto_obj.quantity = '';

        if (typeof val == "string") {
          val = parseFloat(val.replace(/,/g, "")).toFixed(6);
        } else {
          val = val.toFixed(6);
        }

        if (typeof this.proposalItemCargoDto_obj.quantity == "string") {
          this.proposalItemCargoDto_obj.quantity = parseFloat(this.proposalItemCargoDto_obj.quantity.replace(/,/g, "")).toFixed(6);
          this.proposalItemCargoDto_obj.quantity = '';
        } else {
          this.proposalItemCargoDto_obj.quantity = this.proposalItemCargoDto_obj.quantity.toFixed(6);
          this.proposalItemCargoDto_obj.quantity = '';
        }

        this.proposalItemCargoDto_obj.totalAmount = accMul(val, this.proposalItemCargoDto_obj.quantity);
      } else {
        this.proposalItemCargoDto_obj.totalAmount = "";
      }
    },
    // 总价
    totalAmount_ch: function totalAmount_ch(val) {
      if (val != accMul(this.proposalItemCargoDto_obj.unitAmount, this.proposalItemCargoDto_obj.quantity)) {
        this.proposalItemCargoDto_obj.unitAmount = '0';
      }
    },
    //
    lastYearPayAmountChange: function lastYearPayAmountChange(val) {
      var _this2 = this;

      var data = {
        'tradeCodeScc': '',
        'tradeNameCn': ''
      };
      rinkoLastYearPayAmount(data).then(function (res) {
        console.log(res);

        if ('0000' == res.rtnCode) {
          if (res.taxAmountSum != '' && res.taxAmountSum != null) {
            _this2.ruleForm.productCsbp.lastYearPayAmount = res.taxAmountSum;
            _this2.taxAmountSumFlag = true;
          } else {
            _this2.$message({
              message: '查询临港接口数据返回为空',
              type: 'warning'
            });

            return;
          }
        }
      });
    },
    // 初始化
    Init_get: function Init_get() {
      var _this3 = this;

      var type = this.$route.params.type;
      this.ruleForm.applicationNo = this.$route.params.applicationNo;

      if (type === 'view' || type === 'modify') {
        rinkoApplicationCheck({
          'applicationNo': this.ruleForm.applicationNo
        }).then(function (res) {
          if (type == "view") {
            _this3.checkList = [];
          }

          if (res.applicationImageList != null) {
            _this3.upimgsNum = res.applicationImageList.length;

            for (var i = 0; i < res.applicationImageList.length; i++) {
              var obj = {};
              var formData = new FormData();
              var base64 = 'data:image/png;base64,' + res.applicationImageList[i].base64;
              var base64url = res.applicationImageList[i].base64;
              var imagCode = res.applicationImageList[i].imagCode;
              var proposalNo = res.applicationImageList[i].proposalNo;
              var applicationNo = res.applicationImageList[i].applicationNo;
              var claimCode = res.applicationImageList[i].claimCode;
              var fileSrc = res.applicationImageList[i].imagUrl;
              var fileName = res.applicationImageList[i].fileName;
              var imagUseType = res.applicationImageList[i].imagUseType; // 转换base64到file

              var toFile = require('data-uri-to-file');

              toFile(base64).then(function (filed) {
                formData.append('imageName', filed);
                obj.raw = filed;
              });
              obj['type'] = 'old';
              obj['url'] = base64;
              obj.imagCode = imagCode;
              obj.applicationNo = applicationNo;
              obj.proposalNo = proposalNo;
              obj.claimCode = claimCode;
              obj.base64url = base64url;
              obj.fileSrc = fileSrc;
              obj.name = fileName;

              if (imagUseType == '1') {
                _this3.fileList1.push(obj);
              } else if (imagUseType == '2') {
                _this3.fileList2.push(obj);
              } else if (imagUseType == '3') {
                _this3.fileList3.push(obj);
              } else if (imagUseType == '4') {
                _this3.fileList4.push(obj);
              } else if (imagUseType == '5') {
                _this3.fileList5.push(obj);
              } else if (imagUseType == '6') {
                _this3.fileList6.push(obj);
              } else if (imagUseType == '9') {
                _this3.fileList7.push(obj);
              }
            }
          } // 初入页面的基础信息


          if (res.basicInfo != null) {
            _this3.ruleForm.basicInfo.customCompanyName = res.basicInfo.customCompanyName;
            _this3.ruleForm.basicInfo.linkmanDeptCode = res.basicInfo.linkmanDeptCode;
            _this3.ruleForm.basicInfo.linkmanEmail = res.basicInfo.linkmanEmail;
            _this3.ruleForm.basicInfo.linkmanName = res.basicInfo.linkmanName;
            _this3.ruleForm.basicInfo.linkmanDeptName = res.basicInfo.linkmanDeptName;
            _this3.ruleForm.basicInfo.linkmanPhone = res.basicInfo.linkmanPhone;
          } // 团体人身意外伤害保险


          if (res.basicInfo != null && res.basicInfo.insureIntentionStr != '') {
            var insureIntention = res.basicInfo.insureIntentionStr;

            if (insureIntention.indexOf('1') > -1) {
              _this3.ruleForm.basicInfo.insureIntention.push('1');

              if (type == 'view') {
                _this3.checkList.push({
                  label: '人身意外伤害保险',
                  code: '1'
                });

                if (_this3.activeName == 0) {
                  _this3.activeName = '1';
                }
              }

              if (res.productAgap != null) {
                _this3.ruleForm.productAgap.additionRiskInsureAmount = res.productAgap.additionRiskInsureAmount;
                _this3.ruleForm.productAgap.mainRisk = res.productAgap.mainRisk;
                _this3.ruleForm.productAgap.additionRisk = res.productAgap.additionRisk;
                _this3.ruleForm.productAgap.mainRiskInsureAmount = res.productAgap.mainRiskInsureAmount;
                _this3.ruleForm.productAgap.industry = res.productAgap.industry;
                _this3.ruleForm.productAgap.typeWork = res.productAgap.typeWork;
                _this3.ruleForm.productAgap.insuranceEndDate = res.productAgap.insuranceEndDate;
                _this3.ruleForm.productAgap.insuranceStartDate = res.productAgap.insuranceStartDate;
                _this3.ruleForm.productAgap.insureNumber = res.productAgap.insureNumber;
              } else {
                console.log('人身意外伤害保险');
              }
            } // 关税保证保险


            if (insureIntention.indexOf('3') > -1) {
              _this3.ruleForm.basicInfo.insureIntention.push('3');

              if (type == 'view') {
                _this3.checkList.push({
                  label: '关税保证保险',
                  code: '3'
                });

                if (_this3.activeName == 0) {
                  _this3.activeName = '3';
                }
              }

              if (res.productCsbp != null) {
                _this3.ruleForm.productCsbp.amount = res.productCsbp.amount;
                _this3.ruleForm.productCsbp.declareCustoms = res.productCsbp.declareCustoms;
                _this3.ruleForm.productCsbp.policyPurpose = res.productCsbp.policyPurpose;
                _this3.ruleForm.productCsbp.legalRepresent = res.productCsbp.legalRepresent;
                _this3.ruleForm.productCsbp.lastYearPayAmount = res.productCsbp.lastYearPayAmount;
                _this3.ruleForm.productCsbp.customsRegisterCode = res.productCsbp.customsRegisterCode;
                _this3.ruleForm.productCsbp.insuranceEndDate = res.productCsbp.insuranceEndDate;
                _this3.ruleForm.productCsbp.authorizedAgent = res.productCsbp.authorizedAgent;
                _this3.ruleForm.productCsbp.isShortInsure = res.productCsbp.isShortInsure;
                _this3.ruleForm.productCsbp.orgCode = res.productCsbp.orgCode;
                _this3.ruleForm.productCsbp.registerCustoms = res.productCsbp.registerCustoms;
                _this3.ruleForm.productCsbp.insuranceStartDate = res.productCsbp.insuranceStartDate;
                _this3.ruleForm.productCsbp.insuredName = res.productCsbp.insuredName;
                _this3.ruleForm.productCsbp.customsCreditGrade = res.productCsbp.customsCreditGrade;
              } else {
                console.log('关税保证保险');
              }
            } // 安全生产责任保险


            if (insureIntention.indexOf('6') > -1) {
              _this3.ruleForm.basicInfo.insureIntention.push('6');

              if (type == 'view') {
                _this3.checkList.push({
                  label: '安全生产责任保险',
                  code: '6'
                });

                if (_this3.activeName == 0) {
                  _this3.activeName = '6';
                }
              }

              if (res.productSpdp != null) {
                _this3.ruleForm.productSpdp.isOnWork = res.productSpdp.isOnWork;
                _this3.ruleForm.productSpdp.constructNo = res.productSpdp.constructNo;
                _this3.ruleForm.productSpdp.insuranceCompanyCode = res.productSpdp.insuranceCompanyCode;
                _this3.ruleForm.productSpdp.insuranceEndDate = res.productSpdp.insuranceEndDate;
                _this3.ruleForm.productSpdp.insuranceStartDate = res.productSpdp.insuranceStartDate;
                _this3.ruleForm.productSpdp.projectName = res.productSpdp.projectName;
                _this3.ruleForm.productSpdp.insuranceCompanyName = res.productSpdp.insuranceCompanyName;
              } else {
                console.log('安全生产责任保险');
              }
            } // 贸易信用保险


            if (insureIntention.indexOf('7') > -1) {
              _this3.ruleForm.basicInfo.insureIntention.push('7');

              if (type == 'view') {
                _this3.checkList.push({
                  label: '出口贸易信用保险（短期）',
                  code: '7'
                });

                if (_this3.activeName == 0) {
                  _this3.activeName = '7';
                }
              }

              if (res.productTcrp != null) {
                _this3.ruleForm.productTcrp.payCondition = res.productTcrp.payCondition;
                _this3.ruleForm.productTcrp.lastYearSalesAmount = res.productTcrp.lastYearSalesAmount;
                _this3.ruleForm.productTcrp.predictYearSalesAmount = res.productTcrp.predictYearSalesAmount;
                _this3.ruleForm.productTcrp.historyTradeAgeLimit = res.productTcrp.historyTradeAgeLimit;
                _this3.ruleForm.productTcrp.payConditionName = res.productTcrp.payConditionName;
                _this3.ruleForm.productTcrp.applyCreditQuota = res.productTcrp.applyCreditQuota;
                _this3.ruleForm.productTcrp.isWarrant = res.productTcrp.isWarrant;
                _this3.ruleForm.productTcrp.buyerCompanyName = res.productTcrp.buyerCompanyName;
                _this3.ruleForm.productTcrp.insuranceCompanyCode = res.productTcrp.insuranceCompanyCode;
                _this3.ruleForm.productTcrp.insuranceEndDate = res.productTcrp.insuranceEndDate;
                _this3.ruleForm.productTcrp.insuranceCompanyName = res.productTcrp.insuranceCompanyName;
                _this3.ruleForm.productTcrp.tibRegisterNo = res.productTcrp.tibRegisterNo;
                _this3.ruleForm.productTcrp.insuranceStartDate = res.productTcrp.insuranceStartDate;
              } else {
                console.log('出口贸易信用保险（短期）');
              }
            } // 产品责任保险


            if (insureIntention.indexOf('2') > -1) {
              _this3.ruleForm.basicInfo.insureIntention.push('2');

              if (type == 'view') {
                _this3.checkList.push({
                  label: '出口产品责任保险',
                  code: '2'
                });

                if (_this3.activeName == 0) {
                  _this3.activeName = '2';
                }
              }

              if (res.productLprl != null) {
                _this3.ruleForm.productLprl.deadCompLimitAmount = res.productLprl.deadCompLimitAmount;
                _this3.ruleForm.productLprl.isInDangerPrevious = res.productLprl.isInDangerPrevious;
                _this3.ruleForm.productLprl.totalCompLimitAmount = res.productLprl.totalCompLimitAmount;
                _this3.ruleForm.productLprl.lossCompLimitAmount = res.productLprl.lossCompLimitAmount;
                _this3.ruleForm.productLprl.validationFlag = res.productLprl.validationFlag;
                _this3.ruleForm.productLprl.insuranceEndDate = res.productLprl.insuranceEndDate;
                _this3.ruleForm.productLprl.productGenerateDate = res.productLprl.productGenerateDate;
                _this3.ruleForm.productLprl.insuranceStartDate = res.productLprl.insuranceStartDate;
                _this3.ruleForm.productLprl.saleSumAmount = res.productLprl.saleSumAmount;
                _this3.ruleForm.productLprl.isInsurePrevious = res.productLprl.isInsurePrevious;
                _this3.ruleForm.productLprl.compLimitAmount = res.productLprl.compLimitAmount;
                _this3.ruleForm.productLprl.everyCompLimitAmount = res.productLprl.everyCompLimitAmount;
                _this3.ruleForm.productLprl.lprlItemList = res.productLprl.lprlItemList;
              } else {
                console.log('出口产品责任保险');
              }
            } // 货物运输保险


            if (insureIntention.indexOf('4') > -1) {
              _this3.ruleForm.basicInfo.insureIntention.push('4');

              if (type == 'view') {
                _this3.checkList.push({
                  label: '货物运输保险',
                  code: '4'
                });

                if (_this3.activeName == 0) {
                  _this3.activeName = '4';
                }
              }

              if (res.productCargo != null) {
                if (res.productCargo.productCargoConveyItem != null) {
                  _this3.ruleForm.productCargo.productCargoConveyItem.storagePeriod = res.productCargo.productCargoConveyItem.storagePeriod;
                  _this3.ruleForm.productCargo.productCargoConveyItem.termsOfTrade = res.productCargo.productCargoConveyItem.termsOfTrade;
                  _this3.ruleForm.productCargo.productCargoConveyItem.billCurrencyName = res.productCargo.productCargoConveyItem.billCurrencyName;
                  _this3.ruleForm.productCargo.productCargoConveyItem.customsListNo = res.productCargo.productCargoConveyItem.customsListNo;
                  _this3.ruleForm.productCargo.productCargoConveyItem.freight = res.productCargo.productCargoConveyItem.freight;
                  _this3.ruleForm.productCargo.productCargoConveyItem.conveyanceWayCode = res.productCargo.productCargoConveyItem.conveyanceWayCode;
                  _this3.ruleForm.productCargo.productCargoConveyItem.isContainer = res.productCargo.productCargoConveyItem.isContainer;
                  _this3.ruleForm.productCargo.productCargoConveyItem.isRefrigeRate = res.productCargo.productCargoConveyItem.isRefrigeRate;
                  _this3.ruleForm.productCargo.productCargoConveyItem.remark = res.productCargo.productCargoConveyItem.remark;
                  _this3.ruleForm.productCargo.productCargoConveyItem.invoicNo = res.productCargo.productCargoConveyItem.invoicNo;
                  _this3.ruleForm.productCargo.productCargoConveyItem.marks = res.productCargo.productCargoConveyItem.marks;
                  _this3.ruleForm.productCargo.productCargoConveyItem.insuranceCompanyCode = res.productCargo.productCargoConveyItem.insuranceCompanyCode;
                  _this3.ruleForm.productCargo.productCargoConveyItem.insuranceCompanyName = res.productCargo.productCargoConveyItem.insuranceCompanyName;
                  _this3.ruleForm.productCargo.productCargoConveyItem.ladingNO = res.productCargo.productCargoConveyItem.ladingNO;
                  _this3.ruleForm.productCargo.productCargoConveyItem.packingWay = res.productCargo.productCargoConveyItem.packingWay;
                  _this3.ruleForm.productCargo.productCargoConveyItem.billAmount = res.productCargo.productCargoConveyItem.billAmount;
                  _this3.ruleForm.productCargo.productCargoConveyItem.conveyanceWayName = res.productCargo.productCargoConveyItem.conveyanceWayName;
                  _this3.ruleForm.productCargo.productCargoConveyItem.freightCurrency = res.productCargo.productCargoConveyItem.freightCurrency;
                  _this3.ruleForm.productCargo.productCargoConveyItem.billCurrency = res.productCargo.productCargoConveyItem.billCurrency;
                  _this3.ruleForm.productCargo.productCargoConveyItem.packingWayCode = res.productCargo.productCargoConveyItem.packingWayCode;
                  _this3.ruleForm.productCargo.productCargoConveyItem.freightCurrencyName = res.productCargo.productCargoConveyItem.freightCurrencyName;
                  _this3.ruleForm.productCargo.productCargoConveyItem.startTime = res.productCargo.productCargoConveyItem.startTime;
                  _this3.ruleForm.productCargo.productCargoConveyItem.clinchWayName = res.productCargo.productCargoConveyItem.clinchWayName;
                  _this3.ruleForm.productCargo.productCargoConveyItem.clinchWayCode = res.productCargo.productCargoConveyItem.clinchWayCode;
                  _this3.ruleForm.productCargo.productCargoConveyItem.policyNo = res.productCargo.productCargoConveyItem.policyNo;
                } else {
                  console.log('货物运输保险1');
                }
              } //货物运输保险


              if (res.productCargo != null) {
                _this3.ruleForm.productCargo.cargoConveyList = res.productCargo.cargoConveyList;
                _this3.ruleForm.productCargo.cargoItemList = res.productCargo.cargoItemList;
              } else {
                console.log('货物运输保险2');
              }
            } // 财产一切险


            if (insureIntention.indexOf('5') > -1) {
              _this3.ruleForm.basicInfo.insureIntention.push('5');

              if (type == 'view') {
                _this3.checkList.push({
                  label: '企业财产保险',
                  code: '5'
                });

                if (_this3.activeName == 0) {
                  _this3.activeName = '5';
                }
              }

              if (res.productFpap != null) {
                _this3.ruleForm.productFpap.cityCode = res.productFpap.cityCode;
                _this3.ruleForm.productFpap.provinceCode = res.productFpap.provinceCode;
                _this3.ruleForm.productFpap.postalCode = res.productFpap.postalCode;
                _this3.ruleForm.productFpap.businessNature = res.productFpap.businessNature;
                _this3.ruleForm.productFpap.engageInsuranceSum = res.productFpap.engageInsuranceSum;
                _this3.ruleForm.productFpap.insuranceEndDate = res.productFpap.insuranceEndDate;
                _this3.ruleForm.productFpap.insuranceSum = res.productFpap.insuranceSum;
                _this3.ruleForm.productFpap.areaCode = res.productFpap.areaCode;
                _this3.ruleForm.productFpap.totalInsuranceAmount = res.productFpap.totalInsuranceAmount;
                _this3.ruleForm.productFpap.cityName = res.productFpap.cityName;
                _this3.ruleForm.productFpap.areaName = res.productFpap.areaName;
                _this3.ruleForm.productFpap.detailAddress = res.productFpap.detailAddress;
                _this3.ruleForm.productFpap.provinceName = res.productFpap.provinceName;
                _this3.ruleForm.productFpap.insuranceStartDate = res.productFpap.insuranceStartDate;
                _this3.ruleForm.productFpap.insureNumber = res.productFpap.insureNumber; // this.ruleForm.productFpap.fpapItemList =  res.productFpap.fpapItemList

                _this3.ruleForm.productFpap.fpapItemList1 = [];
                _this3.ruleForm.productFpap.fpapItemList2 = [];
                _this3.ruleForm.productFpap.fpapItemList3 = [];

                if (res.productFpap.fpapItemList != null && res.productFpap.fpapItemList.length > 0) {
                  for (var i = 0; i < res.productFpap.fpapItemList.length; i++) {
                    if (res.productFpap.fpapItemList[i].itemUseType === '1') {
                      console.log('res.productFpap.fpapItemList[i]');
                      console.log(res.productFpap.fpapItemList[i]);

                      _this3.ruleForm.productFpap.fpapItemList1.push(res.productFpap.fpapItemList[i]);
                    } else if (res.productFpap.fpapItemList[i].itemUseType === '2') {
                      _this3.ruleForm.productFpap.fpapItemList2.push(res.productFpap.fpapItemList[i]);
                    } else if (res.productFpap.fpapItemList[i].itemUseType === '3') {
                      _this3.ruleForm.productFpap.fpapItemList3.push(res.productFpap.fpapItemList[i]);
                    }
                  }
                }
              } else {
                console.log('企业财产保险');
              }
            }

            if (type == "view") {
              _this3.isViewType = true;
              _this3.isViewUploadGoods = false;
              _this3.delAddShowFlag = false;
              _this3.ruleForm.applicationNo = _this3.$route.params.applicationNo;
              _this3.tabList = _this3.checkList;
              _this3.wYtFalg = true;
            } else if (type == "modify") {
              if (_this3.ruleForm.basicInfo.insureIntention.length == 0) {
                _this3.insureIntentionFlag = false;
                _this3.tabList = [];
              } else {
                _this3.insureIntentionFlag = true;
                var list = _this3.ruleForm.basicInfo.insureIntention;

                for (var i = 0; i < list.length; i++) {
                  for (var j = 0; j < _this3.checkList.length; j++) {
                    if (list[i] == _this3.checkList[j].code) {
                      _this3.tabList[i] = _this3.checkList[j];
                    }
                  }
                }

                _this3.activeName = _this3.tabList[0].code;
              }
            }
          }
        });
      }
    },
    // 获取省市区
    getAreaList: function getAreaList() {
      var _this4 = this;

      getProvinceCityArea({}).then(function (res) {
        _this4.areaListArr = res;
      });
    },
    // 启运城市
    startSiteCountryCode_ch: function startSiteCountryCode_ch(val, scope) {
      this.codeTypeList_fun3(val, scope, '1');
      this.ProposalConveyanceDto.proposalConveyanceListDtoList[scope.$index].startSiteCountryName = this.list_select(val, this.country_option);
      this.ProposalConveyanceDto.proposalConveyanceListDtoList[scope.$index].startSiteCityCode = '';

      if (val == null || val == '' || this.ProposalConveyanceDto.proposalConveyanceListDtoList[scope.$index].startSiteCityCode == null || this.ProposalConveyanceDto.proposalConveyanceListDtoList[scope.$index].startSiteCityCode == '') {
        this.text4.startSiteCountryCode = '不为空';
      } else {
        this.text4.startSiteCountryCode = '';
      }

      if (val == null || val == '') {
        $('.startSiteCountryCode').eq(scope.$index).find('input').css({
          'border': '1px solid #f56c6c'
        });
      } else {
        $('.startSiteCountryCode').eq(scope.$index).find('input').css({
          'border': '1px solid #dcdfe6'
        });
      }
    },
    startSiteCityCode_ch: function startSiteCityCode_ch(val, scope) {
      this.ProposalConveyanceDto.proposalConveyanceListDtoList[scope.$index].startSiteCityName = this.list_select(val, scope.row.city_option1);

      if (val == null || val == '' || this.ProposalConveyanceDto.proposalConveyanceListDtoList[scope.$index].startSiteCountryCode == null || this.ProposalConveyanceDto.proposalConveyanceListDtoList[scope.$index].startSiteCountryCode == '') {
        this.text4.startSiteCountryCode = '不为空';
      } else {
        this.text4.startSiteCountryCode = '';
      }

      if (val == null || val == '') {
        $('.startSiteCityCode').eq(scope.$index).find('input').css({
          'border': '1px solid #f56c6c'
        });
      } else {
        $('.startSiteCityCode').eq(scope.$index).find('input').css({
          'border': '1px solid #dcdfe6'
        });
      }
    },
    // 目的地
    endSiteCountryCode_ch: function endSiteCountryCode_ch(val, scope) {
      this.codeTypeList_fun3(val, scope, '2');
      this.ProposalConveyanceDto.proposalConveyanceListDtoList[scope.$index].endSiteCountryName = this.list_select(val, this.country_option);
      this.ProposalConveyanceDto.proposalConveyanceListDtoList[scope.$index].endSiteCityCode = '';

      if (val == null || val == '' || this.ProposalConveyanceDto.proposalConveyanceListDtoList[scope.$index].endSiteCityCode == null || this.ProposalConveyanceDto.proposalConveyanceListDtoList[scope.$index].endSiteCityCode == '') {
        this.text4.endSiteCountryCode = '不为空';
      } else {
        this.text4.endSiteCountryCode = '';
      }

      if (val == null || val == '') {
        $('.endSiteCountryCode').eq(scope.$index).find('input').css({
          'border': '1px solid #f56c6c'
        });
      } else {
        $('.endSiteCountryCode').eq(scope.$index).find('input').css({
          'border': '1px solid #dcdfe6'
        });
      }
    },
    endSiteCityCode_ch: function endSiteCityCode_ch(val, scope) {
      this.ProposalConveyanceDto.proposalConveyanceListDtoList[scope.$index].endSiteCityName = this.list_select(val, scope.row.city_option2);

      if (val == null || val == '' || this.ProposalConveyanceDto.proposalConveyanceListDtoList[scope.$index].endSiteCountryCode == null || this.ProposalConveyanceDto.proposalConveyanceListDtoList[scope.$index].endSiteCountryCode == '') {
        this.text4.endSiteCountryCode = '不为空';
      } else {
        this.text4.endSiteCountryCode = '';
      }

      if (val == null || val == '') {
        $('.endSiteCityCode').eq(scope.$index).find('input').css({
          'border': '1px solid #f56c6c'
        });
      } else {
        $('.endSiteCityCode').eq(scope.$index).find('input').css({
          'border': '1px solid #dcdfe6'
        });
      }
    },
    // 其他运输工具
    blName_ch: function blName_ch(val, scope) {
      if (val == null || val == '') {
        /* this.text4.blName = "请输入其他运输工具"
          $('.blName').eq(scope.$index).find('input').css({
            'border': '1px solid #f56c6c'
          })*/
      } else {
        this.text4.blName = '';
        $('.blName').eq(scope.$index).find('input').css({
          'border': '1px solid #ccc'
        });
      }
    },
    // 船舶航次
    voyageNo_ch: function voyageNo_ch(val, scope) {
      if (this.ProposalConveyanceDto.conveyanceWayCode == '3' || this.ProposalConveyanceDto.conveyanceWayCode == '8' || this.ProposalConveyanceDto.conveyanceWayCode == '10') {
        if (val == null || val == '') {
          /* this.text4.voyageNo = "请输入船舶航次"
            $('.voyageNo').eq(scope.$index).find('input').css({
              'border': '1px solid #f56c6c'
            })*/
          this.text4.voyageNo = '';
        } else {
          this.text4.voyageNo = '';
          $('.voyageNo').eq(scope.$index).find('input').css({
            'border': '1px solid #ccc'
          });
        }
      }
    },
    // 船级
    shipClassCode_ch: function shipClassCode_ch(val, scope) {
      this.ProposalConveyanceDto.proposalConveyanceListDtoList[scope.$index].shipClassName = this.list_select(val, this.shipClass_option);

      if (this.ProposalConveyanceDto.conveyanceWayCode == '3' || this.ProposalConveyanceDto.conveyanceWayCode == '8' || this.ProposalConveyanceDto.conveyanceWayCode == '10') {
        if (val == null || val == '') {
          /* this.text4.shipClassCode = "请输入船舶航次"
            $('.shipClassCode').eq(scope.$index).find('input').css({
              'border': '1px solid #f56c6c'
            })*/
        } else {
          this.text4.shipClassCode = '';
          $('.shipClassCode').eq(scope.$index).find('input').css({
            'border': '1px solid #ccc'
          });
        }
      }
    },
    // 获取船舶 港口数据
    port_ship: function port_ship(val) {
      var _this5 = this;

      var data = {
        vslName: val,
        flag: '2'
      };
      newShipInformation(data).then(function (res) {
        if (res.resultCode == "0000") {
          _this5.shipFlag = true;

          if (res.resultObj.length == 1) {
            _this5.tableData_ship = res.resultObj;
            var index = _this5.ship_index;
            _this5.ruleForm.productCargo.cargoConveyList[index].blName = res.resultObj[0].vslNameEn;

            if (res.resultObj[0].roCode !== null && res.resultObj[0].roName !== null) {
              _this5.ruleForm.productCargo.cargoConveyList[index].shipClassCode = res.resultObj[0].roCode;
              _this5.ruleForm.productCargo.cargoConveyList[index].shipClassName = res.resultObj[0].roName;
            } else {
              _this5.ruleForm.productCargo.cargoConveyList[index].shipClassCode = '';
              _this5.ruleForm.productCargo.cargoConveyList[index].shipClassName = '';
            }

            if (res.resultObj[0].msaVesselTypeCode !== null && res.resultObj[0].msaVesselTypeName !== null) {
              _this5.ruleForm.productCargo.cargoConveyList[index].shipTypesCode = res.resultObj[0].msaVesselTypeCode;
              _this5.ruleForm.productCargo.cargoConveyList[index].shipTypes = res.resultObj[0].msaVesselTypeName;
            } else {
              _this5.ruleForm.productCargo.cargoConveyList[index].shipTypesCode = '';
              _this5.ruleForm.productCargo.cargoConveyList[index].shipTypes = '';
            }

            if (res.resultObj[0].shipAge !== null) {
              _this5.ruleForm.productCargo.cargoConveyList[index].vessel = res.resultObj[0].shipAge;
            } else {
              _this5.ruleForm.productCargo.cargoConveyList[index].vessel = '';
            } // YCKK-1376 船舶接口调用之后航次字段前端不赋值优化
            // if (res.resultObj[0].voyage !== null ){
            //   this.ruleForm.productCargo.cargoConveyList[index].voyageNo = res.resultObj[0].voyage
            // }else {
            //   this.ruleForm.productCargo.cargoConveyList[index].voyageNo = ''
            // }

          } else {
            _this5.tableData_ship = res.resultObj;
            _this5.dialogFormVisible2 = true;
          }
        } else {
          _this5.$alert('<p>' + res.resultMsg + '</p>', '', {
            dangerouslyUseHTMLString: true,
            confirmButtonText: '确定',
            callback: function callback(action) {}
          });
        }

        _this5.loing_box = false;
      }, function (res) {
        _this5.loing_box = false;
      });
    },
    // 船舶类型
    shipTypesCode_ch: function shipTypesCode_ch(val, scope) {
      console.log(this.ProposalConveyanceDto.proposalConveyanceListDtoList[scope.$index]);
      this.ProposalConveyanceDto.proposalConveyanceListDtoList[scope.$index].shipTypes = this.list_select(val, this.shipTypes_option);

      if (this.ProposalConveyanceDto.conveyanceWayCode == '3' || this.ProposalConveyanceDto.conveyanceWayCode == '8' || this.ProposalConveyanceDto.conveyanceWayCode == '10') {
        if (val == null || val == '') {
          /* this.text4.shipTypesCode = "请输入船舶航次"
            $('.shipTypesCode').eq(scope.$index).find('input').css({
              'border': '1px solid #f56c6c'
            })*/
        } else {
          this.text4.shipTypesCode = '';
          $('.shipTypesCode').eq(scope.$index).find('input').css({
            'border': '1px solid #ccc'
          });
        }
      }
    },
    // 船龄
    vessel_ch: function vessel_ch(val, scope) {
      var index = scope.$index;
      this.ProposalConveyanceDto.proposalConveyanceListDtoList[index].vessel = val.replace(/-/g, '');

      if (this.ProposalConveyanceDto.conveyanceWayCode == '3' || this.ProposalConveyanceDto.conveyanceWayCode == '8' || this.ProposalConveyanceDto.conveyanceWayCode == '10') {
        if (val == null || val == '') {
          /* this.text4.vessel = "请输入船舶航次"
            $('.vessel').eq(scope.$index).find('input').css({
              'border': '1px solid #f56c6c'
            })*/
        } else {
          this.text4.vessel = '';
          $('.vessel').eq(scope.$index).find('input').css({
            'border': '1px solid #ccc'
          });
        }
      }
    },
    // ------  下拉信息集合函数
    select_data: function select_data(code) {
      // this.findInsuranceCompany_fun(code)
      // this.companyqueryAll_fun(code)
      // this.biaodi_fun()
      this.codeTypeList_fun();
      this.codeTypeList_fun2();
    },
    // ------------------------国家
    codeTypeList_fun2: function codeTypeList_fun2() {
      var list = getCountryList();
      this.countryAll = getCountryList();
      this.countryCount = Math.floor(this.countryAll.length / 10);
      this.country_option = [];

      for (var k = 0; k < list.length; k++) {
        // for (var k = 0; k < 10; k++) {
        var obj = {};
        obj.value = this.countryAll[k].codeCode;
        obj.label = this.countryAll[k].codeCname + ' - ' + this.countryAll[k].codeEname;
        this.country_option.push(obj);
      }
    },
    //			下拉集合
    codeTypeList_fun: function codeTypeList_fun() {
      var _this6 = this;

      var data = {
        'codeLever': '1',
        'codeType': ['conveyance', 'tradeTerms', 'currency', 'packType', 'idCard', 'measuringUnit', 'isneworold', 'isneworold', 'shipClass', 'shipTypes', 'itemType', 'itemType']
      };
      codeTypeList(data).then(function (res) {
        var plk = {
          label: '请选择',
          value: ''
        };
        _this6.conveyance_option = [plk];
        _this6.tradeTerms_option = [plk];
        _this6.currency_option = [plk];
        _this6.packType_option = [plk];
        _this6.idCard_option = [];
        _this6.measuringUnit_option = [];
        _this6.shipClass_option = [plk];
        _this6.shipTypes_option = [plk];

        for (var i = 0; i < res.length; i++) {
          if (res[i].codeType == 'conveyance') {
            for (var k = 0; k < res[i].dictionary.length; k++) {
              var obj = {};
              obj.value = res[i].dictionary[k].codeCode;
              obj.label = res[i].dictionary[k].codeCname;

              _this6.conveyance_option.push(obj);
            }
          }

          if (res[i].codeType == 'tradeTerms') {
            for (var k = 0; k < res[i].dictionary.length; k++) {
              var obj = {};
              obj.value = res[i].dictionary[k].codeCode;
              obj.label = res[i].dictionary[k].codeCname;

              if (res[i].dictionary[k].codeCname != 'COST' && res[i].dictionary[k].codeCname != 'INVOICE VALUE' && res[i].dictionary[k].codeCname != 'ACTUAL VALUE' && res[i].dictionary[k].codeCname != 'SEE REMARKS') {
                _this6.tradeTerms_option.push(obj);
              }
            }
          }

          if (res[i].codeType == 'currency') {
            for (var k = 0; k < res[i].dictionary.length; k++) {
              var obj = {};
              obj.value = res[i].dictionary[k].codeCode;
              obj.label = res[i].dictionary[k].codeCname + ' - ' + res[i].dictionary[k].codeCode; // console.log(obj)

              _this6.currency_option.push(obj);
            }
          }

          if (res[i].codeType == 'packType') {
            for (var k = 0; k < res[i].dictionary.length; k++) {
              var obj = {};
              obj.value = res[i].dictionary[k].codeCode;
              obj.label = res[i].dictionary[k].codeCname + ' - ' + res[i].dictionary[k].codeEname;

              _this6.packType_option.push(obj);
            }
          }

          if (res[i].codeType == 'idCard') {
            for (var k = 0; k < res[i].dictionary.length; k++) {
              var obj = {};
              obj.value = res[i].dictionary[k].codeCode;
              obj.label = res[i].dictionary[k].codeCname;

              _this6.idCard_option.push(obj);
            }
          }

          if (res[i].codeType == 'measuringUnit') {
            for (var k = 0; k < res[i].dictionary.length; k++) {
              var obj = {};
              obj.value = res[i].dictionary[k].codeCode;
              obj.label = res[i].dictionary[k].codeCname + ' - ' + res[i].dictionary[k].codeEname;

              _this6.measuringUnit_option.push(obj);
            }
          }

          if (res[i].codeType == 'isneworold') {
            _this6.isneworold_option = [];

            for (var k = 0; k < res[i].dictionary.length; k++) {
              var obj = {};
              obj.value = res[i].dictionary[k].codeCode;
              obj.label = res[i].dictionary[k].codeCname;

              _this6.isneworold_option.push(obj);
            }
          } // 船级社 / 船舶类型


          if (res[i].codeType == 'shipClass') {
            _this6.shipClass_option = [];

            for (var k = 0; k < res[i].dictionary.length; k++) {
              var obj = {};
              obj.value = res[i].dictionary[k].codeCode;
              obj.label = res[i].dictionary[k].codeCname;

              _this6.shipClass_option.push(obj);
            }
          }

          if (res[i].codeType == 'shipTypes') {
            _this6.shipTypes_option = [];

            for (var k = 0; k < res[i].dictionary.length; k++) {
              var obj = {};
              obj.value = res[i].dictionary[k].codeCode;
              obj.label = res[i].dictionary[k].codeCname;

              _this6.shipTypes_option.push(obj);
            }
          }

          if (res[i].codeType == 'itemType') {
            _this6.itemType_option = [];

            for (var k = 0; k < res[i].dictionary.length; k++) {
              var obj = {};
              obj.value = res[i].dictionary[k].codeCode;
              obj.label = res[i].dictionary[k].codeCname;

              _this6.itemType_option.push(obj);
            }
          }
        } //					console.log(res)

      });
    },
    // 下拉框通过code 获取 name值函数
    list_select: function list_select(val, list) {
      var obj = {};
      obj = list.find(function (item) {
        // 这里的userList就是上面遍历的数据源
        return item.value === val; // 筛选出匹配数据
      });
      return obj.label;
    },
    //			----------------城市
    codeTypeList_fun3: function codeTypeList_fun3(code, scope, type) {
      console.log(code, scope.$index, type);
      this.city_option1 = [];
      this.city_option2 = [];

      if (code == 'CHN') {
        var list = getCHNCity();

        if (type == '1') {
          var arr1 = [];

          for (var k = 0; k < list.length; k++) {
            var obj = {};
            obj.value = list[k].codeCode;
            obj.label = list[k].codeCname + ' - ' + list[k].codeEname;
            this.city_option1.push(obj);
          }
        } else if (type == '2') {
          var arr2 = [];

          for (var k = 0; k < list.length; k++) {
            var obj = {};
            obj.value = list[k].codeCode;
            obj.label = list[k].codeCname + ' - ' + list[k].codeEname;
            this.city_option2.push(obj);
          }
        }
      } else {
        var list = getUnderCity(code);

        if (type == '1') {
          var arr1 = [];

          for (var k = 0; k < list.length; k++) {
            var obj = {};
            obj.value = list[k].codeCode;
            obj.label = list[k].codeCname + ' - ' + list[k].codeEname;
            this.city_option1.push(obj);
          }
        } else if (type == '2') {
          var arr2 = [];

          for (var k = 0; k < list.length; k++) {
            var obj = {};
            obj.value = list[k].codeCode;
            obj.label = list[k].codeCname + ' - ' + list[k].codeEname;
            this.city_option2.push(obj);
          }
        }
      }
    },
    submitForm: function submitForm(formName) {
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          alert('submit!');
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm: function resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    typeChaneg: function typeChaneg(value) {
      var _this7 = this;

      console.log(value);
      console.log(this.ruleForm.basicInfo.insureIntention);

      if (this.ruleForm.basicInfo.insureIntention.length > 0) {
        this.insureIntentionFlag = true;
      }

      this.tabList = this.checkList.filter(function (item) {
        return _this7.ruleForm.basicInfo.insureIntention.indexOf(item.code) > -1;
      });
      this.activeName = this.tabList.length > 0 ? this.tabList[0].code : '';

      if (this.ruleForm.basicInfo.insureIntention.length == 0) {
        this.insureIntentionFlag = false;
      }
    },
    handleClick: function handleClick(val) {},
    removeThisProduct: function removeThisProduct(item) {
      if (this.tableData2.length < 2) {
        this.$message.warning('保留一条信息');
        return;
      }

      this.tableData2.splice(item, 1);
    },
    addThisProduct: function addThisProduct() {
      var obj = {
        date: '',
        name: '',
        checkOptions: [],
        address: ''
      };
      this.tableData2.push(obj);
    },
    applicationSubmit: function applicationSubmit(formName, type) {
      var _this8 = this;

      // 1、暂存  2、提交
      console.log('暂存/提交类型(1、暂存  2、提交):' + type);
      var submitFlag = false;

      if (type == '1') {
        submitFlag = true;
      } else if (type == 2) {
        if (this.fileList7.length > 0) {
          if (!this.isList7) {
            this.$message({
              message: '请先上传【安全生产责任保险】中的影像信息',
              type: 'error'
            });
            return;
          }
        }

        if (this.fileList1.length > 0) {
          if (!this.isList1) {
            this.$message({
              message: '请先上传【关税保证保险】中的影像信息',
              type: 'error'
            });
            return;
          }
        }

        if (this.fileList2.length > 0) {
          if (!this.isList1) {
            this.$message({
              message: '请先上传【关税保证保险】中的影像信息',
              type: 'error'
            });
            return;
          }
        }

        if (this.fileList3.length > 0) {
          if (!this.isList1) {
            this.$message({
              message: '请先上传【关税保证保险】中的影像信息',
              type: 'error'
            });
            return;
          }
        }

        if (this.fileList4.length > 0) {
          if (!this.isList1) {
            this.$message({
              message: '请先上传【关税保证保险】中的影像信息',
              type: 'error'
            });
            return;
          }
        }

        if (this.fileList5.length > 0) {
          if (!this.isList1) {
            this.$message({
              message: '请先上传【关税保证保险】中的影像信息',
              type: 'error'
            });
            return;
          }
        }

        if (this.fileList6.length > 0) {
          if (!this.isList1) {
            this.$message({
              message: '请先上传【关税保证保险】中的影像信息',
              type: 'error'
            });
            return;
          }
        } // 提交是先校验基本信息中的必填项


        var basicValid = false;
        this.$refs['ruleForm.basicInfo'].validate(function (valid) {
          if (valid) {
            basicValid = true;
          } else {
            basicValid = false;
          }
        });

        if (!basicValid) {
          this.$message({
            message: '基本信息必填项不能为空',
            type: 'warning'
          });
          return;
        }

        submitFlag = true;
        var insureIntent = this.ruleForm.basicInfo.insureIntention;

        if (insureIntent.length > 0) {
          //校验投保意向信息
          submitFlag = this.validCheckForm(insureIntent);

          if (!submitFlag) {
            this.$message({
              message: '请完成投保意向中的必填项',
              type: "warning"
            });
            return;
          }
        }
      }

      this.ruleForm.productFpap.fpapItemList = [];

      if (this.ruleForm.basicInfo.insureIntention.indexOf('5') > -1) {
        this.ruleForm.productFpap.fpapItemList1.map(function (item, index) {
          _this8.ruleForm.productFpap.fpapItemList.push(Object.assign({}, item));
        });
        this.ruleForm.productFpap.fpapItemList2.map(function (item, index) {
          _this8.ruleForm.productFpap.fpapItemList.push(Object.assign({}, item));
        });
        this.ruleForm.productFpap.fpapItemList3.map(function (item, index) {
          _this8.ruleForm.productFpap.fpapItemList.push(Object.assign({}, item));
        });
      }

      console.log(this.ruleForm.productFpap.fpapItemList.length);

      if (submitFlag) {
        if (this.shipFlag) {
          this.ruleForm.shipInvokeFlag = '1';
        } else {
          this.ruleForm.shipInvokeFlag = '0';
        }

        var para = {
          'submitType': type,
          'shipInvokeFlag': this.ruleForm.shipInvokeFlag,
          'basicInfo': this.ruleForm.basicInfo,
          'applicationNo': this.ruleForm.applicationNo,
          'productAgap': this.ruleForm.productAgap,
          'productLprl': this.ruleForm.productLprl,
          'productFpap': this.ruleForm.productFpap,
          'productCsbp': this.ruleForm.productCsbp,
          'productCargo': this.ruleForm.productCargo,
          'productSpdp': this.ruleForm.productSpdp,
          'productTcrp': this.ruleForm.productTcrp
        };
        rinkoApplicationSubmit(para).then(function (res) {
          if (res.resultCode === '0000') {
            if (type === '1') {
              // 暂存成功后还可以继续进行操作
              _this8.loading = false;

              _this8.$message({
                message: '暂存成功',
                type: 'success'
              });

              _this8.ruleForm.applicationNo = res.applicationNo;
              _this8.ruleForm.insuranceCompanyCode = res.insuranceCompanyCode;
              _this8.ruleForm.insuranceCompanyName = res.insuranceCompanyName;
            } else {
              // 保存成功后，跳转到列表页面
              _this8.$message({
                type: 'success',
                message: res.resultMessage
              });

              _this8.$store.dispatch('delVisitedViews', _this8.$route);

              _this8.$router.go(-1);
            }
          } else {
            console.log(res.resultCode);

            if (res.resultCode === '9999') {
              _this8.$message.error(res.rtnMsg);
            } else {
              _this8.$message.error('保存失败，请联系管理员。');
            }

            _this8.loading = false;
          }
        }).catch(function (err) {
          console.log(err.message); // this.$message.error('保存失败，请联系管理员。')

          _this8.loading = false;
        });
      }
    },
    // 投保取消
    cancel: function cancel() {
      // 返回上一步路由
      this.$router.go(-1); // 关闭导航栏

      this.$store.dispatch('delVisitedViews', this.$route);
    },
    mainRiskSelect: function mainRiskSelect(val) {
      console.log('val', val);
      console.log(this.ruleForm.productAgap.mainRisk);

      if (val === '1') {
        this.ruleForm.productAgap.mainRisk = '0';
        this.$forceUpdate();
      } else {
        this.ruleForm.productAgap.mainRisk = '1';
        this.$forceUpdate();
      }
    },
    httpRequest: function httpRequest(data) {},
    // 图片上传成功后1
    success_img1: function success_img1(response, file, fileList) {
      this.fileList1 = fileList;
    },
    // 图片上传成功后2
    success_img2: function success_img2(response, file, fileList) {
      this.fileList2 = fileList;
    },
    // 图片上传成功后3
    success_img3: function success_img3(response, file, fileList) {
      this.fileList3 = fileList;
    },
    // 图片上传成功后4
    success_img4: function success_img4(response, file, fileList) {
      this.fileList4 = fileList;
    },
    // 图片上传成功后5
    success_img5: function success_img5(response, file, fileList) {
      this.fileList5 = fileList;
    },
    // 图片上传成功后6
    success_img6: function success_img6(response, file, fileList) {
      this.fileList6 = fileList;
    },
    // 图片上传成功后7
    success_img7: function success_img7(response, file, fileList) {
      this.fileList7 = fileList;
    },
    look_img: function look_img(file) {
      if (file.fileSrc == undefined || file.fileSrc == '') {
        console.log('未上传到服务器');
        this.$message({
          message: '请检查该文件是否已经进行上传影像',
          type: 'warning'
        });
      } else {
        var data = {
          fileSrc: file.fileSrc
        };
        rinkoImageView(data).then(function (res) {
          var blob = new Blob([res], {
            type: ''
          });
          var url = window.URL.createObjectURL(blob);
          console.log(url);
          var link = document.createElement('a'); // 创建a标签

          link.href = url;
          link.download = file.name; // 重命名文件

          link.click();
          URL.revokeObjectURL(url); // 释放内存
        });
      }
    },
    // 图片上传时1
    handlePictureCardPreview1: function handlePictureCardPreview1(file) {
      this.fileList1.push(file);
    },
    // 图片上传时2
    handlePictureCardPreview2: function handlePictureCardPreview2(file) {
      this.fileList2.push(file);
    },
    // 图片上传时3
    handlePictureCardPreview3: function handlePictureCardPreview3(file) {
      this.fileList3.push(file);
    },
    // 图片上传时4
    handlePictureCardPreview4: function handlePictureCardPreview4(file) {
      this.fileList4.push(file);
    },
    // 图片上传时5
    handlePictureCardPreview5: function handlePictureCardPreview5(file) {
      this.fileList5.push(file);
    },
    // 图片上传时6
    handlePictureCardPreview6: function handlePictureCardPreview6(file) {
      this.fileList6.push(file);
    },
    // 图片上传时7
    handlePictureCardPreview7: function handlePictureCardPreview7(file) {
      this.fileList7.push(file);
    },
    // 图片删除时1
    handleRemove1: function handleRemove1(file, fileList) {
      var _this9 = this;

      var formData = new FormData();
      var objimg = {
        rinkoImageDetailDtoList: [{
          base64Src: file.base64url,
          claimCode: this.claimCode,
          fileName: file.name,
          fileSrc: file.fileSrc,
          imagCode: file.imagCode
        }]
      };
      rinkoImageDel(objimg).then(function (res) {
        _this9.fileList1 = fileList;
      });
    },
    // 图片删除时2
    handleRemove2: function handleRemove2(file, fileList) {
      var _this10 = this;

      var formData = new FormData();
      var objimg = {
        rinkoImageDetailDtoList: [{
          base64Src: file.base64url,
          claimCode: this.claimCode,
          fileName: file.name,
          fileSrc: file.fileSrc,
          imagCode: file.imagCode
        }]
      };
      rinkoImageDel(objimg).then(function (res) {
        _this10.fileList2 = fileList;
      });
    },
    // 图片删除时3
    handleRemove3: function handleRemove3(file, fileList) {
      var _this11 = this;

      var formData = new FormData();
      var objimg = {
        rinkoImageDetailDtoList: [{
          base64Src: file.base64url,
          claimCode: this.claimCode,
          fileName: file.name,
          fileSrc: file.fileSrc,
          imagCode: file.imagCode
        }]
      };
      rinkoImageDel(objimg).then(function (res) {
        _this11.fileList3 = fileList;
      });
    },
    // 图片删除时4
    handleRemove4: function handleRemove4(file, fileList) {
      var _this12 = this;

      var formData = new FormData();
      var objimg = {
        rinkoImageDetailDtoList: [{
          base64Src: file.base64url,
          claimCode: this.claimCode,
          fileName: file.name,
          fileSrc: file.fileSrc,
          imagCode: file.imagCode
        }]
      };
      rinkoImageDel(objimg).then(function (res) {
        _this12.fileList4 = fileList;
      });
    },
    // 图片删除时5
    handleRemove5: function handleRemove5(file, fileList) {
      var _this13 = this;

      var formData = new FormData();
      var objimg = {
        rinkoImageDetailDtoList: [{
          base64Src: file.base64url,
          claimCode: this.claimCode,
          fileName: file.name,
          fileSrc: file.fileSrc,
          imagCode: file.imagCode
        }]
      };
      rinkoImageDel(objimg).then(function (res) {
        _this13.fileList5 = fileList;
      });
    },
    // 图片删除时6
    handleRemove6: function handleRemove6(file, fileList) {
      var _this14 = this;

      var formData = new FormData();
      var objimg = {
        rinkoImageDetailDtoList: [{
          base64Src: file.base64url,
          claimCode: this.claimCode,
          fileName: file.name,
          fileSrc: file.fileSrc,
          imagCode: file.imagCode
        }]
      };
      rinkoImageDel(objimg).then(function (res) {
        _this14.fileList6 = fileList;
      });
    },
    // 图片删除时7
    handleRemove7: function handleRemove7(file, fileList) {
      var _this15 = this;

      var formData = new FormData();
      var objimg = {
        rinkoImageDetailDtoList: [{
          base64Src: file.base64url,
          claimCode: this.claimCode,
          fileName: file.name,
          fileSrc: file.fileSrc,
          imagCode: file.imagCode
        }]
      };
      rinkoImageDel(objimg).then(function (res) {
        _this15.fileList7 = fileList;
      });
    },
    // 判断上传影像文件类型1
    beforeUploadimg1: function beforeUploadimg1(file) {
      var isLt2M = file.size / 1024 / 1024 < 5;
      var isold = true;
      var isnumber = true; // 判断文件名是否重复

      var count = 0;
      this.fileList1.forEach(function (item, idx) {
        if (idx > 19) {
          isnumber = false;
        }

        if (file.name == item.name) {
          count++;

          if (count == 1) {
            isold = true;
          }

          if (count === 2) {
            isold = false;
          }
        }
      });

      if (!isold) {
        this.$message({
          message: '上传文件已存在，请确认后重新上传!',
          type: 'warning'
        });
      }

      if (!isLt2M) {
        this.$message({
          message: '上传文件大小不能超过 5MB!',
          type: 'warning'
        });
      }

      if (!isnumber) {
        this.$message({
          message: '最多支持上传20个文件!',
          type: 'warning'
        });
      }

      return isLt2M && isold && isnumber;
    },
    // 判断上传影像文件类型2
    beforeUploadimg2: function beforeUploadimg2(file) {
      var isLt2M = file.size / 1024 / 1024 < 5;
      var isold = true;
      var isnumber = true; // 判断文件名是否重复

      var count = 0;
      this.fileList2.forEach(function (item, idx) {
        if (idx > 19) {
          isnumber = false;
        }

        if (file.name == item.name) {
          count++;

          if (count == 1) {
            isold = true;
          }

          if (count === 2) {
            isold = false;
          }
        }
      });

      if (!isold) {
        this.$message({
          message: '上传文件已存在，请确认后重新上传!',
          type: 'warning'
        });
      }

      if (!isLt2M) {
        this.$message({
          message: '上传文件大小不能超过 5MB!',
          type: 'warning'
        });
      }

      if (!isnumber) {
        this.$message({
          message: '最多支持上传20个文件!',
          type: 'warning'
        });
      }

      return isLt2M && isold && isnumber;
    },
    // 判断上传影像文件类型3
    beforeUploadimg3: function beforeUploadimg3(file) {
      var isLt2M = file.size / 1024 / 1024 < 5;
      var isold = true;
      var isnumber = true; // 判断文件名是否重复

      var count = 0;
      this.fileList3.forEach(function (item, idx) {
        if (idx > 19) {
          isnumber = false;
        }

        if (file.name == item.name) {
          count++;

          if (count == 1) {
            isold = true;
          }

          if (count === 2) {
            isold = false;
          }
        }
      });

      if (!isold) {
        this.$message({
          message: '上传文件已存在，请确认后重新上传!',
          type: 'warning'
        });
      }

      if (!isLt2M) {
        this.$message({
          message: '上传文件大小不能超过 5MB!',
          type: 'warning'
        });
      }

      if (!isnumber) {
        this.$message({
          message: '最多支持上传20个文件!',
          type: 'warning'
        });
      }

      return isLt2M && isold && isnumber;
    },
    // 判断上传影像文件类型4
    beforeUploadimg4: function beforeUploadimg4(file) {
      var isLt2M = file.size / 1024 / 1024 < 5;
      var isold = true;
      var isnumber = true; // 判断文件名是否重复

      var count = 0;
      this.fileList4.forEach(function (item, idx) {
        if (idx > 19) {
          isnumber = false;
        }

        if (file.name == item.name) {
          count++;

          if (count == 1) {
            isold = true;
          }

          if (count === 2) {
            isold = false;
          }
        }
      });

      if (!isold) {
        this.$message({
          message: '上传文件已存在，请确认后重新上传!',
          type: 'warning'
        });
      }

      if (!isLt2M) {
        this.$message({
          message: '上传文件大小不能超过 5MB!',
          type: 'warning'
        });
      }

      if (!isnumber) {
        this.$message({
          message: '最多支持上传20个文件!',
          type: 'warning'
        });
      }

      return isLt2M && isold && isnumber;
    },
    // 判断上传影像文件类型5
    beforeUploadimg5: function beforeUploadimg5(file) {
      var isLt2M = file.size / 1024 / 1024 < 5;
      var isold = true;
      var isnumber = true; // 判断文件名是否重复

      var count = 0;
      this.fileList5.forEach(function (item, idx) {
        if (idx > 19) {
          isnumber = false;
        }

        if (file.name == item.name) {
          count++;

          if (count == 1) {
            isold = true;
          }

          if (count === 2) {
            isold = false;
          }
        }
      });

      if (!isold) {
        this.$message({
          message: '上传文件已存在，请确认后重新上传!',
          type: 'warning'
        });
      }

      if (!isLt2M) {
        this.$message({
          message: '上传文件大小不能超过 5MB!',
          type: 'warning'
        });
      }

      if (!isnumber) {
        this.$message({
          message: '最多支持上传20个文件!',
          type: 'warning'
        });
      }

      return isLt2M && isold && isnumber;
    },
    // 判断上传影像文件类型6
    beforeUploadimg6: function beforeUploadimg6(file) {
      var isLt2M = file.size / 1024 / 1024 < 5;
      var isold = true;
      var isnumber = true; // 判断文件名是否重复

      var count = 0;
      this.fileList6.forEach(function (item, idx) {
        if (idx > 19) {
          isnumber = false;
        }

        if (file.name == item.name) {
          count++;

          if (count == 1) {
            isold = true;
          }

          if (count === 2) {
            isold = false;
          }
        }
      });

      if (!isold) {
        this.$message({
          message: '上传文件已存在，请确认后重新上传!',
          type: 'warning'
        });
      }

      if (!isLt2M) {
        this.$message({
          message: '上传文件大小不能超过 5MB!',
          type: 'warning'
        });
      }

      if (!isnumber) {
        this.$message({
          message: '最多支持上传20个文件!',
          type: 'warning'
        });
      }

      return isLt2M && isold && isnumber;
    },
    // 判断上传影像文件类型7
    beforeUploadimg7: function beforeUploadimg7(file) {
      var isLt2M = file.size / 1024 / 1024 < 5;
      var isold = true;
      var isnumber = true; // 判断文件名是否重复

      var count = 0;
      this.fileList7.forEach(function (item, idx) {
        if (idx > 19) {
          isnumber = false;
        }

        if (file.name == item.name) {
          count++;

          if (count == 1) {
            isold = true;
          }

          if (count === 2) {
            isold = false;
          }
        }
      });

      if (!isold) {
        this.$message({
          message: '上传文件已存在，请确认后重新上传!',
          type: 'warning'
        });
      }

      if (!isLt2M) {
        this.$message({
          message: '上传文件大小不能超过 5MB!',
          type: 'warning'
        });
      }

      if (!isnumber) {
        this.$message({
          message: '最多支持上传20个文件!',
          type: 'warning'
        });
      }

      return isLt2M && isold && isnumber;
    },
    // 提交上传信息
    submitUpload: function submitUpload() {
      var _this16 = this;

      if (this.ruleForm.applicationNo == '' || this.ruleForm.applicationNo == null) {
        this.$message({
          message: '请先进行暂存操作',
          type: 'warning'
        });
        return;
      }

      var formData = new FormData();
      formData.append('applicationNo', this.ruleForm.applicationNo);
      formData.append('insuranceCompanyCode', this.ruleForm.insuranceCompanyCode);
      formData.append('insuranceCompanyName', this.ruleForm.insuranceCompanyName);
      this.fileList = []; // 1.企业营业执照、法人身份证

      for (var i = 0; i < this.fileList1.length; i++) {
        this.fileList.push(this.fileList1[i]);
        this.fileListF = {};
        this.fileListF.imagUse = '1';
        this.fileListF.imagUseType = '1';
        this.fileListF.name = this.fileList1[i].name;
        this.fileListF.imagUseName = this.fileList1[i].imagUseName;
        this.fileListZ.push(this.fileListF);
      } // 2.过往两年审计报告


      for (var _i = 0; _i < this.fileList2.length; _i++) {
        this.fileList.push(this.fileList2[_i]);
        this.fileListF = {};
        this.fileListF.imagUse = '1';
        this.fileListF.imagUseType = '2';
        this.fileListF.name = this.fileList2[_i].name;
        this.fileListF.imagUseName = this.fileList2[_i].imagUseName;
        this.fileListZ.push(this.fileListF);
      } // 3.近期盖章财报


      for (var _i2 = 0; _i2 < this.fileList3.length; _i2++) {
        this.fileList.push(this.fileList3[_i2]);
        this.fileListF = {};
        this.fileListF.imagUse = '1';
        this.fileListF.imagUseType = '3';
        this.fileListF.name = this.fileList3[_i2].name;
        this.fileListF.imagUseName = this.fileList3[_i2].imagUseName;
        this.fileListZ.push(this.fileListF);
      } // 4.近1月内企业征信报告


      for (var _i3 = 0; _i3 < this.fileList4.length; _i3++) {
        this.fileList.push(this.fileList4[_i3]);
        this.fileListF = {};
        this.fileListF.imagUse = '1';
        this.fileListF.imagUseType = '4';
        this.fileListF.name = this.fileList4[_i3].name;
        this.fileListF.imagUseName = this.fileList4[_i3].imagUseName;
        this.fileListZ.push(this.fileListF);
      } // 5.报价申请表


      for (var _i4 = 0; _i4 < this.fileList5.length; _i4++) {
        this.fileList.push(this.fileList5[_i4]);
        this.fileListF = {};
        this.fileListF.imagUse = '1';
        this.fileListF.imagUseType = '5';
        this.fileListF.name = this.fileList5[_i4].name;
        this.fileListF.imagUseName = this.fileList5[_i4].imagUseName;
        this.fileListZ.push(this.fileListF);
      } // 6.尽调人企合照


      for (var _i5 = 0; _i5 < this.fileList6.length; _i5++) {
        this.fileList.push(this.fileList6[_i5]);
        this.fileListF = {};
        this.fileListF.imagUse = '1';
        this.fileListF.imagUseType = '6';
        this.fileListF.name = this.fileList6[_i5].name;
        this.fileListF.imagUseName = this.fileList6[_i5].imagUseName;
        this.fileListZ.push(this.fileListF);
      } // // 7.项目总包合同
      // for (let i = 0; i < this.fileList7.length; i++) {
      //   this.fileList.push(this.fileList7[i])
      //   this.fileListF = {}
      //   this.fileListF.imagUse = '4'
      //   this.fileListF.imagUseType = '9'
      //   this.fileListF.name = this.fileList7[i].name
      //   this.fileListF.imagUseName = this.fileList7[i].imagUseName
      //   this.fileListZ.push(this.fileListF)
      // }


      formData.append('fileLis', JSON.stringify(this.fileListZ)); // 影像列表

      if (this.fileList.length > 0) {
        var m = 0;
        var newarray = [];

        for (var _j = 0; _j < this.fileList.length; _j++) {
          var status = 0;

          for (var _i6 = 0; _i6 < this.fileList.length; _i6++) {
            if (this.fileList[_j].name == this.fileList[_i6].name) {
              status = status + 1;
            }

            if (status > 1) {
              this.$message({
                message: '上传文件名字有重复，请确认！ 重复文件名：' + this.fileList[_i6].name,
                type: 'error'
              });
              return;
            }
          }
        }

        for (var j = 0; j < this.fileList.length; j++) {
          if (this.fileList[j].raw && this.fileList[j].type != 'old') {
            if (m < 10) {
              formData.append('files', this.fileList[j].raw);
              this.fileList[j]['type'] = 'old';
            }

            m++;
          }
        }

        rinkoImageUploads(formData).then(function (res) {
          if (res.rtnCode == '0000') {
            _this16.$message({
              message: res.data,
              type: 'success'
            });

            _this16.isList1 = true;
            var k = 0;

            for (var i = 0; i < _this16.fileList.length; i++) {
              if (!_this16.fileList[i].imagCode && k < 10) {
                _this16.fileList[i].fileSrc = res.detailDtoList[k].fileSrc;
                _this16.fileList[i].imagCode = res.detailDtoList[k].imagCode;
                _this16.fileList[i].base64url = res.detailDtoList[k].base64Src;
                _this16.fileList[i].proposalNo = res.detailDtoList[k].proposalNo;
                _this16.fileList[i].applicationNo = res.detailDtoList[k].applicationNo;
                _this16.fileList[i].claimCode = _this16.claimCode;
                newarray.push(_this16.fileList[i]);
                k++;
              }
            }

            console.log(newarray.length);

            if (newarray.length > 9) {
              _this16.submitUpload2();
            } else {
              $('.el-upload-list__item-status-label').css('display', 'block');

              _this16.$message({
                message: res.data,
                type: 'success'
              });

              _this16.upimgsNum = _this16.fileList.length;
              _this16.isUpimg = true;
            }
          } else {
            _this16.$message({
              message: '没有待上传的影像',
              type: 'error'
            });
          }
        }, function (res) {});
      } else {
        this.$message({
          message: '没有待上传的影像',
          type: 'error'
        });
      }
    },
    submitUpload2: function submitUpload2() {
      var _this17 = this;

      if (this.fileList.length > 0) {
        var formData = new FormData();
        formData.append('applicationNo', this.ruleForm.applicationNo);
        formData.append('insuranceCompanyCode', this.ruleForm.insuranceCompanyCode);
        formData.append('insuranceCompanyName', this.ruleForm.insuranceCompanyName);

        for (var i = 0; i < this.fileList.length; i++) {
          if (this.fileList[i].raw && this.fileList[i].type != 'old') {
            formData.append('files', this.fileList[i].raw);
            this.fileList[i]['type'] = 'old';
          }
        }

        formData.append('fileLis', JSON.stringify(this.fileListZ));
        rinkoImageUploads(formData).then(function (res) {
          if (res.rtnCode == '0000') {
            $('.el-upload-list__item-status-label').css('display', 'block');

            _this17.$message({
              message: res.data,
              type: 'success'
            });

            _this17.upimgsNum = _this17.fileList.length;
            _this17.isUpimg = true;
            var k = 0;

            for (var i = 0; i < _this17.fileList.length; i++) {
              if (!_this17.fileList[i].imagCode) {
                _this17.fileList[i].fileSrc = res.detailDtoList[k].fileSrc;
                _this17.fileList[i].imagCode = res.detailDtoList[k].imagCode;
                _this17.fileList[i].base64url = res.detailDtoList[k].base64Src;
                _this17.fileList[i].proposalNo = res.detailDtoList[k].proposalNo;
                _this17.fileList[i].applicationNo = res.detailDtoList[k].applicationNo;
                _this17.fileList[i].claimCode = _this17.claimCode;
                k++;
              }
            }
          } else {
            _this17.$message({
              message: '没有待上传的影像',
              type: 'error'
            });
          }
        }, function (res) {});
      } else {
        this.$message({
          message: '没有待上传的影像',
          type: 'error'
        });
      }
    },
    // 提交上传信息
    submitUpload1: function submitUpload1() {
      var _this18 = this;

      if (this.ruleForm.applicationNo == '' || this.ruleForm.applicationNo == null) {
        this.$message({
          message: '请先进行暂存操作',
          type: 'warning'
        });
        return;
      }

      var formData = new FormData();
      formData.append('applicationNo', this.ruleForm.applicationNo);
      formData.append('insuranceCompanyCode', this.ruleForm.insuranceCompanyCode);
      formData.append('insuranceCompanyName', this.ruleForm.insuranceCompanyName);
      this.fileList = []; // 7.项目总包合同

      for (var i = 0; i < this.fileList7.length; i++) {
        this.fileList.push(this.fileList7[i]);
        this.fileListF = {};
        this.fileListF.imagUse = '4';
        this.fileListF.imagUseType = '9';
        this.fileListF.name = this.fileList7[i].name;
        this.fileListF.imagUseName = this.fileList7[i].imagUseName;
        this.fileListZ.push(this.fileListF);
      }

      formData.append('fileLis', JSON.stringify(this.fileListZ)); // 影像列表

      if (this.fileList.length > 0) {
        var m = 0;
        var newarray = [];

        for (var _j2 = 0; _j2 < this.fileList.length; _j2++) {
          var status = 0;

          for (var _i7 = 0; _i7 < this.fileList.length; _i7++) {
            if (this.fileList[_j2].name == this.fileList[_i7].name) {
              status = status + 1;
            }

            if (status > 1) {
              this.$message({
                message: '上传文件名字有重复，请确认！ 重复文件名：' + this.fileList[_i7].name,
                type: 'error'
              });
              return;
            }
          }
        }

        for (var j = 0; j < this.fileList.length; j++) {
          if (this.fileList[j].raw && this.fileList[j].type != 'old') {
            if (m < 10) {
              formData.append('files', this.fileList[j].raw);
              this.fileList[j]['type'] = 'old';
            }

            m++;
          }
        }

        rinkoImageUploads(formData).then(function (res) {
          if (res.rtnCode == '0000') {
            _this18.$message({
              message: res.data,
              type: 'success'
            });

            _this18.isList7 = true;
            var k = 0;

            if (_this18.fileList != null && _this18.fileList.length > 0) {
              for (var i = 0; i < _this18.fileList.length; i++) {
                if (!_this18.fileList[i].imagCode && k < 10) {
                  _this18.fileList[i].fileSrc = res.detailDtoList[k].fileSrc;
                  _this18.fileList[i].imagCode = res.detailDtoList[k].imagCode;
                  _this18.fileList[i].base64url = res.detailDtoList[k].base64Src;
                  _this18.fileList[i].proposalNo = res.detailDtoList[k].proposalNo;
                  _this18.fileList[i].applicationNo = res.detailDtoList[k].applicationNo;
                  _this18.fileList[i].claimCode = _this18.claimCode;
                  newarray.push(_this18.fileList[i]);
                  k++;
                }
              }
            }

            console.log(newarray.length);

            if (newarray.length > 9) {
              _this18.submitUpload3();
            } else {
              $('.el-upload-list__item-status-label').css('display', 'block');

              _this18.$message({
                message: res.data,
                type: 'success'
              });

              _this18.upimgsNum = _this18.fileList.length;
              _this18.isUpimg = true;
            }
          } else {
            _this18.$message({
              message: '没有待上传的影像',
              type: 'error'
            });
          }
        }, function (res) {});
      } else {
        this.$message({
          message: '没有待上传的影像',
          type: 'error'
        });
      }
    },
    submitUpload3: function submitUpload3() {
      var _this19 = this;

      if (this.fileList.length > 0) {
        var formData = new FormData();
        formData.append('applicationNo', this.ruleForm.applicationNo);
        formData.append('insuranceCompanyCode', this.ruleForm.insuranceCompanyCode);
        formData.append('insuranceCompanyName', this.ruleForm.insuranceCompanyName);

        for (var i = 0; i < this.fileList.length; i++) {
          if (this.fileList[i].raw && this.fileList[i].type != 'old') {
            formData.append('files', this.fileList[i].raw);
            this.fileList[i]['type'] = 'old';
          }
        }

        formData.append('fileLis', JSON.stringify(this.fileListZ));
        rinkoImageUploads(formData).then(function (res) {
          if (res.rtnCode == '0000') {
            $('.el-upload-list__item-status-label').css('display', 'block');

            _this19.$message({
              message: res.data,
              type: 'success'
            });

            _this19.upimgsNum = _this19.fileList.length;
            _this19.isUpimg = true;
            var k = 0;

            for (var i = 0; i < _this19.fileList.length; i++) {
              if (!_this19.fileList[i].imagCode) {
                _this19.fileList[i].fileSrc = res.detailDtoList[k].fileSrc;
                _this19.fileList[i].imagCode = res.detailDtoList[k].imagCode;
                _this19.fileList[i].base64url = res.detailDtoList[k].base64Src;
                _this19.fileList[i].proposalNo = res.detailDtoList[k].proposalNo;
                _this19.fileList[i].applicationNo = res.detailDtoList[k].applicationNo;
                _this19.fileList[i].claimCode = _this19.claimCode;
                k++;
              }
            }
          } else {
            _this19.$message({
              message: '没有待上传的影像',
              type: 'error'
            });
          }
        }, function (res) {});
      } else {
        this.$message({
          message: '没有待上传的影像',
          type: 'error'
        });
      }
    },
    addTransport: function addTransport() {
      // 运输信息添加
      var length = this.ruleForm.productCargo.cargoConveyList.length;
      var obj = {
        voyageNumber: length + 1,
        startSiteCountryCode: '',
        startSiteCountryName: '',
        startSiteCityCode: '',
        startSiteCityName: '',
        city_option1: '',
        endSiteCountryCode: '',
        endSiteCountryName: '',
        endSiteCityCode: '',
        endSiteCityName: '',
        blName: '',
        voyageNo: '',
        shipClassCode: '',
        shipClassName: '',
        shipTypesCode: '',
        shipTypes: '',
        vessel: ''
      };

      if (length > 0) {
        obj.startSiteCountryCode = this.ruleForm.productCargo.cargoConveyList[length - 1].endSiteCountryCode;
        obj.startSiteCountryName = this.ruleForm.productCargo.cargoConveyList[length - 1].endSiteCountryName;
        obj.startSiteCityCode = this.ruleForm.productCargo.cargoConveyList[length - 1].endSiteCityCode;
        obj.startSiteCityName = this.ruleForm.productCargo.cargoConveyList[length - 1].endSiteCityCode;

        if (this.ruleForm.productCargo.cargoConveyList[length - 1].endSiteCountryCode == 'CHN') {
          var list1 = getCHNCity();
          var arr1 = [];

          for (var k = 0; k < list1.length; k++) {
            var obj1 = {};
            obj1.value = list1[k].codeCode;
            obj1.label = list1[k].codeCname;
            arr1.push(obj1);
          }

          obj.city_option1 = arr1;
        } else {
          var list1 = getUnderCity(this.ruleForm.productCargo.cargoConveyList[length - 1].endSiteCountryCode);
          var arr1 = [];

          for (var k = 0; k < list1.length; k++) {
            var obj1 = {};
            obj1.value = list1[k].codeCode;
            obj1.label = list1[k].codeCname;
            arr1.push(obj1);
          }

          obj.city_option1 = arr1;
        }
      }

      this.ruleForm.productCargo.cargoConveyList.push(obj);
      console.log(this.ruleForm.productCargo.cargoConveyList);
    },
    delTransport: function delTransport(index) {
      this.ruleForm.productCargo.cargoConveyList.splice(index, 1);
      var length = this.ruleForm.productCargo.cargoConveyList.length;

      for (var k = 0; k < length; k++) {
        this.ruleForm.productCargo.cargoConveyList[k].voyageNumber = k + 1;
      }
    },
    //选择船舶信息-- 选择
    select_radio_s: function select_radio_s(val, row) {
      console.log(row);
      this.select_radio_s_obj = row;
    },
    //选择船舶信息-- 确定
    dialogFormVisible2_submit: function dialogFormVisible2_submit() {
      debugger;

      if (this.radio2 == null) {
        this.$message({
          message: '请选择一条信息',
          type: 'warning'
        });
        return;
      }

      var index = this.ship_index;
      this.ruleForm.productCargo.cargoConveyList[index].blName = this.select_radio_s_obj.row.vslNameEn;

      if (this.select_radio_s_obj.row.roName !== null && this.select_radio_s_obj.row.roCode !== null) {
        this.ruleForm.productCargo.cargoConveyList[index].shipClassCode = this.select_radio_s_obj.row.roCode;
        this.ruleForm.productCargo.cargoConveyList[index].shipClassName = this.select_radio_s_obj.row.roName;
      } else {
        this.ruleForm.productCargo.cargoConveyList[index].shipClassCode = '';
        this.ruleForm.productCargo.cargoConveyList[index].shipClassName = '';
      }

      if (this.select_radio_s_obj.row.msaVesselTypeName !== null && this.select_radio_s_obj.row.msaVesselTypeCode !== null) {
        this.ruleForm.productCargo.cargoConveyList[index].shipTypesCode = this.select_radio_s_obj.row.msaVesselTypeCode;
        this.ruleForm.productCargo.cargoConveyList[index].shipTypes = this.select_radio_s_obj.row.msaVesselTypeName;
      } else {
        this.ruleForm.productCargo.cargoConveyList[index].shipTypesCode = '';
        this.ruleForm.productCargo.cargoConveyList[index].shipTypes = '';
      }

      if (this.select_radio_s_obj.row.shipAge !== null) {
        this.ruleForm.productCargo.cargoConveyList[index].vessel = this.select_radio_s_obj.row.shipAge;
      } else {
        this.ruleForm.productCargo.cargoConveyList[index].vessel = '';
      } // YCKK-1376 船舶接口调用之后航次字段前端不赋值优化
      // if(this.select_radio_s_obj.row.voyage !== null ){
      //   this.ruleForm.productCargo.cargoConveyList[index].voyageNo = this.select_radio_s_obj.row.voyage
      // }else {
      //   this.ruleForm.productCargo.cargoConveyList[index].voyageNo = ''
      // }


      this.dialogFormVisible2 = false;
      $('.shipClassCode').eq(index).find('input').css({
        'border': '1px solid #e4e7ed'
      });
      $('.shipTypesCode').eq(index).find('input').css({
        'border': '1px solid #e4e7ed'
      });
      $('.vessel').eq(index).find('input').css({
        'border': '1px solid #e4e7ed'
      });
    },
    // 船舶信息
    shipBox: function shipBox(scope) {
      var temp = this.ruleForm.productCargo.productCargoConveyItem.conveyanceWayCode;

      if (temp == "3" || temp == "8" || temp == "10") {
        this.ship_index = scope.$index;

        if (scope.row.blName == null || scope.row.blName == "") {
          this.$message({
            message: '请输入船名 / 航班号 / 车牌号 / 其他运输工具',
            type: 'warning'
          });
          return;
        }

        var transportname = scope.row.blName;
        console.log('transportname==', transportname);
        this.port_ship(transportname);
      } else {
        this.tableData_ship = [];
        this.dialogFormVisible2 = true;
      }
    },
    delLprlItem: function delLprlItem(index) {
      if (this.ruleForm.productLprl.lprlItemList.length == 1) {
        this.$message({
          message: '数据只有一条的时候不允许删除!',
          type: 'warning'
        });
        return;
      }

      this.ruleForm.productLprl.lprlItemList.splice(index, 1);
      var length = this.ruleForm.productLprl.lprlItemList.length;

      for (var k = 0; k < length; k++) {
        this.ruleForm.productLprl.lprlItemList[k].serialNo = k + 1;
      }
    },
    addLprlItem: function addLprlItem() {
      // 产品信息添加
      var length = this.ruleForm.productLprl.lprlItemList.length;
      var obj = {
        // 序号
        serialNo: length + 1,
        // 产品名称
        itemName: '',
        // 币种名称
        currencyName: '',
        // 销售额
        salesVolume: '',
        // 投保单意向申请号
        applicationNo: '',
        // 产品代码
        itemCode: '',
        // 年销售数量
        annualSalesNum: '',
        // 销售国家和地区
        saleCountryArea: '',
        // 币种
        currency: ''
      };
      this.ruleForm.productLprl.lprlItemList.push(obj);
      console.log(this.ruleForm.productLprl.lprlItemList);
    },
    editCargoItem: function editCargoItem(row) {
      this.matter_flag = row;
      this.dialogFormVisible3 = true;
      this.matter_index = row.$index;
      console.log('matter_index' + this.matter_index);
      this.proposalItemCargoDto_obj = deepcopy(row.row);

      if (typeof this.proposalItemCargoDto_obj.unitAmount === 'string') {
        this.proposalItemCargoDto_obj.unitAmount = parseFloat(this.proposalItemCargoDto_obj.unitAmount.replace(/,/g, ''));
        console.log(this.proposalItemCargoDto_obj.unitAmount, 'dj');
      } else {
        this.proposalItemCargoDto_obj.unitAmount = this.proposalItemCargoDto_obj.unitAmount;
      }

      if (typeof this.proposalItemCargoDto_obj.totalAmount === 'string') {
        this.proposalItemCargoDto_obj.totalAmount = parseFloat(this.proposalItemCargoDto_obj.totalAmount.replace(/,/g, ''));
        console.log(this.proposalItemCargoDto_obj.totalAmount, 'zj');
      } else {
        this.proposalItemCargoDto_obj.totalAmount = this.proposalItemCargoDto_obj.totalAmount;
      }

      this.$refs['proposalItemCargoDto_obj'].resetFields();
    },
    delCargoItem: function delCargoItem(index) {
      this.ruleForm.productCargo.cargoItemList.splice(index, 1);
      this.invoicAmountsum_fun();
    },
    delFpapItem: function delFpapItem(index) {
      if (this.ruleForm.productFpap.fpapItemList1.length == 1) {
        this.$message({
          message: '数据只有一条的时候不允许删除!',
          type: 'warning'
        });
        return;
      }

      this.ruleForm.productFpap.fpapItemList1.splice(index, 1);
      var length = this.ruleForm.productFpap.fpapItemList1.length;

      for (var k = 0; k < length; k++) {
        this.ruleForm.productFpap.fpapItemList1[k].serialNo = k + 1;
      }
    },
    addFpapItem: function addFpapItem() {
      // 保险标的增加
      var length = this.ruleForm.productFpap.fpapItemList1.length;
      var obj = {
        // 序号
        serialNo: length + 1,
        // 险别名称
        riskName: '',
        // 承保标的项目
        underWriteItemProject: '',
        // 保险金额
        insuranceAmount: '',
        // 币种中文名称
        currencyName: '',
        // 标的用途 1、保险标的 2、特约保险标的 3、附加险标的
        itemUseType: '1',
        // 投保单意向申请号
        applicationNo: '',
        // 险别代码
        riskCode: '',
        // 币种
        currency: '',
        // 保险金额确认方式
        amountConfirmWay: ''
      };
      this.ruleForm.productFpap.fpapItemList1.push(obj);
    },
    delFpapEngageItem: function delFpapEngageItem(index) {
      if (this.ruleForm.productFpap.fpapItemList2.length == 1) {
        this.$message({
          message: '数据只有一条的时候不允许删除!',
          type: 'warning'
        });
        return;
      }

      this.ruleForm.productFpap.fpapItemList2.splice(index, 1);
      var length = this.ruleForm.productFpap.fpapItemList2.length;

      for (var k = 0; k < length; k++) {
        this.ruleForm.productFpap.fpapItemList2[k].serialNo = k + 1;
      }
    },
    addFpapEngageItem: function addFpapEngageItem() {
      // 特约保险标的增加
      var length = this.ruleForm.productFpap.fpapItemList2.length;
      var obj = {
        // 序号
        serialNo: length + 1,
        // 险别名称
        riskName: '',
        // 承保标的项目
        underWriteItemProject: '',
        // 保险金额
        insuranceAmount: '',
        // 币种中文名称
        currencyName: '',
        // 标的用途 1、保险标的 2、特约保险标的 3、附加险标的
        itemUseType: '2',
        // 投保单意向申请号
        applicationNo: '',
        // 险别代码
        riskCode: '',
        // 币种
        currency: '',
        // 保险金额确认方式
        amountConfirmWay: ''
      };
      this.ruleForm.productFpap.fpapItemList2.push(obj);
    },
    delFpapAdditionItem: function delFpapAdditionItem(index) {
      if (this.ruleForm.productFpap.fpapItemList3.length == 1) {
        this.$message({
          message: '数据只有一条的时候不允许删除!',
          type: 'warning'
        });
        return;
      }

      this.ruleForm.productFpap.fpapItemList3.splice(index, 1);
      var length = this.ruleForm.productFpap.fpapItemList3.length;

      for (var k = 0; k < length; k++) {
        this.ruleForm.productFpap.fpapItemList3[k].serialNo = k + 1;
      }
    },
    addFpapAdditionItem: function addFpapAdditionItem() {
      // 附加险标的增加
      var length = this.ruleForm.productFpap.fpapItemList3.length;
      var obj = {
        // 序号
        serialNo: length + 1,
        // 险别名称
        riskName: '',
        // 承保标的项目
        underWriteItemProject: '',
        // 保险金额
        insuranceAmount: '',
        // 币种中文名称
        currencyName: '',
        // 标的用途 1、保险标的 2、特约保险标的 3、附加险标的
        itemUseType: '3',
        // 投保单意向申请号
        applicationNo: '',
        // 险别代码
        riskCode: '',
        // 币种
        currency: '',
        // 保险金额确认方式
        amountConfirmWay: ''
      };
      this.ruleForm.productFpap.fpapItemList3.push(obj);
    },
    addItem: function addItem(row) {
      //this.matter_flag = row
      console.log(this.matter_flag);
      this.dialogFormVisible3 = true;
      this.matter_flag == '';
    },
    upload_tem: function upload_tem() {
      this.dialogFormVisible1 = true;

      if (this.ProposalItemDto.proposalItemCargoDtoList == '') {
        this.fileList_exlc = [];
      }
    },
    download_tem: function download_tem() {
      var data_s = {
        "fileDownloadType": "1"
      };
      getPath_biaodi(data_s).then(function (res_s) {
        var data = {
          fileSrc: res_s.fileSrc
        };
        excleCargoDownload_biaodi(data).then(function (res) {
          var blob = new Blob([res], {
            type: "application/vnd.ms-excel"
          });
          console.log(blob);
          var url = window.URL.createObjectURL(blob);
          var link = document.createElement("a"); // 创建a标签

          link.href = url;
          link.download = "货运清单.xlsx"; // 重命名文件

          link.click();
          URL.revokeObjectURL(url); // 释放内存
        });
      });
    },
    // 判断上传货物清单文件类型
    beforeUpload: function beforeUpload(file) {
      var testmsg = file.name.substring(file.name.lastIndexOf('.') + 1);
      var extension = testmsg === 'xls';
      var extension2 = testmsg === 'xlsx'; // const isLt2M = file.size / 1024 / 1024 < 10

      if (!extension && !extension2) {
        this.$message({
          message: '上传文件模板不正确，请确认后重新上传',
          type: 'warning'
        });
      }

      return extension || extension2;
    },
    remove: function remove() {
      this.rule.productCargo.cargoItemList = [];
    },
    //运输信息上传文件后解析 -----  货运险信息
    uploadFile: function () {
      var _uploadFile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(params) {
        var _this20 = this;

        var _file, fileReader, arr, arr1;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _file = params.file;
                fileReader = new FileReader();
                arr = [];
                arr1 = [];

                fileReader.onload = function (ev) {
                  console.log('1234');

                  try {
                    // console.log(ev.target.result)
                    var data = ev.target.result;
                    var workbook = XLSX.read(data, {
                      type: 'binary'
                    });
                    var arr_list = ["HScode", "标的类型", "商品中文名称", "商品英文名称", "数量", "单位", "单价", "总价", "货物新旧标识"];
                    var A1 = workbook.Sheets.Sheet1.A1.h;
                    var B1 = workbook.Sheets.Sheet1.B1.h;
                    var C1 = workbook.Sheets.Sheet1.C1.h;
                    var D1 = workbook.Sheets.Sheet1.D1.h;
                    var E1 = workbook.Sheets.Sheet1.E1.h;
                    var F1 = workbook.Sheets.Sheet1.F1.h;
                    var G1 = workbook.Sheets.Sheet1.G1.h;
                    var H1 = workbook.Sheets.Sheet1.H1.h;
                    var I1 = workbook.Sheets.Sheet1.I1.h;
                    arr1.push(A1, B1, C1, D1, E1, F1, G1, H1, I1); // console.log(arr1)

                    console.log(unique(arr1).toString());
                    console.log("workbook.Sheets为：");
                    console.log(workbook.Sheets);

                    for (var sheet in workbook.Sheets) {
                      //循环读取每个文件
                      var sheetArray = XLSX.utils.sheet_to_json(workbook.Sheets[sheet]); //若当前sheet没有数据，则continue

                      console.log('sheetArray为：');
                      console.log(sheetArray);

                      if (sheetArray.length == 0) {
                        continue;
                      } // 判断上传表格模板字段是否正确


                      if (unique(arr1).toString() === arr_list.toString()) {
                        console.log('正确'); // this.ProposalItemDto.proposalItemCargoDtoList = []

                        for (var item in sheetArray) {
                          var rowTable = {}; //这里的rowTable的属性名注意要与上面表格的prop一致
                          //sheetArray的属性名与上传的表格的列名一致

                          if (item == 0) {
                            if (sheetArray[item].HScode.length > 10) {
                              _this20.$message({
                                message: '货物清单上传模板中的HScode不允许超过十位,请确认输入是否正确',
                                type: 'warning'
                              });

                              _this20.dialogFormVisible1 = false;
                              return;
                            }
                          }

                          if (item == 2) {
                            if (sheetArray[item].商品中文名称.length > 250) {
                              _this20.$message({
                                message: '货物清单上传模板中的商品中文名称不允许超过250个字符,请确认输入是否正确',
                                type: 'warning'
                              });

                              _this20.dialogFormVisible1 = false;
                              return;
                            }
                          }

                          if (item == 3) {
                            if (sheetArray[item].商品英文名称.length > 250) {
                              _this20.$message({
                                message: '货物清单上传模板中的商品英文名称不允许超过250个字符,请确认输入是否正确',
                                type: 'warning'
                              });

                              _this20.dialogFormVisible1 = false;
                              return;
                            }
                          }

                          rowTable.cargoName = sheetArray[item].商品中文名称;
                          rowTable.cargoEnName = sheetArray[item].商品英文名称;
                          rowTable.serialNo = Number(item) + 1;
                          rowTable.itemCode = sheetArray[item].HScode; // console.log(sheetArray[item].数量)

                          if (sheetArray[item].数量 != undefined || sheetArray[item].数量 != null) {
                            rowTable.quantity = sheetArray[item].数量.trim();
                          } // rowTable.unitName = sheetArray[item].单位


                          rowTable.unitAmount = sheetArray[item].单价;
                          rowTable.totalAmount = sheetArray[item].总价;

                          for (var i = 0; i < _this20.isneworold_option.length; i++) {
                            //	console.log(this.isneworold_option[i].label)
                            if (sheetArray[item].货物新旧标识 == _this20.isneworold_option[i].label) {
                              rowTable.isNewOrOld = _this20.isneworold_option[i].value;
                            }

                            if (sheetArray[item].货物新旧标识 == undefined) {
                              rowTable.isNewOrOld = "";
                            }
                          }

                          for (var i = 0; i < _this20.itemType_option.length; i++) {
                            //									console.log(sheetArray[item].标的类型)
                            if (sheetArray[item].标的类型 == _this20.itemType_option[i].label) {
                              rowTable.itemType = _this20.itemType_option[i].value;
                              rowTable.itemTypeName = sheetArray[item].标的类型;
                            }

                            if (sheetArray[item].标的类型 == undefined) {
                              rowTable.itemType = "";
                              rowTable.itemTypeName = "";
                            }
                          }

                          for (var i = 0; i < _this20.measuringUnit_option.length; i++) {
                            var dwlabel = _this20.measuringUnit_option[i].label.substring(0, _this20.measuringUnit_option[i].label.indexOf(" ")); //									console.log(this.measuringUnit_option[i].label)


                            if (sheetArray[item].单位 == dwlabel) {
                              rowTable.unit = _this20.measuringUnit_option[i].value;
                              rowTable.unitName = sheetArray[item].单位;
                            }

                            if (sheetArray[item].单位 == undefined) {
                              rowTable.unit = "";
                              rowTable.unitName = "";
                            }
                          }

                          _this20.ruleForm.productCargo.cargoItemList.push(rowTable);

                          console.log('rowTable为：');
                          console.log(rowTable);
                          console.log('cargoItemList为：');
                          console.log(_this20.ruleForm.productCargo.cargoItemList);
                        }

                        _this20.dialogFormVisible1 = false;

                        _this20.invoicAmountsum_fun();

                        break;
                      } else {
                        _this20.$refs.uploader.clearFiles();

                        _this20.$message.warning('上传文件模板不正确，请确认后重新上传');

                        break;
                      } // console.log("读取文件");

                    }
                  } catch (e) {// this.$message.warning('上传文件模板不正确，请确认后重新上传');
                  }
                };

                fileReader.readAsBinaryString(_file);

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function uploadFile(_x) {
        return _uploadFile.apply(this, arguments);
      }

      return uploadFile;
    }(),
    //运输信息上传文件时弹窗提示错误
    exceed: function exceed() {
      this.$message.error("最多只能上传1个xlsx文件");
    },
    // 选择协议被保险人---关闭
    handleClose: function handleClose() {
      this.dialogFormVisible = false;
      this.radio1 = null;
      this.content = {};
    },
    itemAddCancel: function itemAddCancel() {
      var _this21 = this;

      this.dialogFormVisible3 = false;
      this.proposalItemCargoDto_obj = {
        itemCode: '',
        itemType: '',
        itemTypeName: '',
        cargoCodeName: '',
        cargoName: '',
        cargoEnName: '',
        quantity: '',
        isNewOrOld: '',
        unit: '',
        unitAmount: '0.00',
        totalAmount: '0.00'
      };
      this.$nextTick(function () {
        _this21.$refs['proposalItemCargoDto_obj'].clearValidate();
      });
    },
    itemAddConfirm: function itemAddConfirm(formName) {
      var _this22 = this;

      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this22.dialogFormVisible3 = false; // 涉及 计算0.57或0.58时精度问题

          console.log('确定---------------1');

          if (_this22.matter_flag != '') {
            console.log(_this22.proposalItemCargoDto_obj);
            _this22.ruleForm.productCargo.cargoItemList[_this22.matter_index].cargoEnName = _this22.proposalItemCargoDto_obj.cargoEnName;
            _this22.ruleForm.productCargo.cargoItemList[_this22.matter_index].cargoName = _this22.proposalItemCargoDto_obj.cargoName;
            _this22.ruleForm.productCargo.cargoItemList[_this22.matter_index].isNewOrOld = _this22.proposalItemCargoDto_obj.isNewOrOld;
            _this22.ruleForm.productCargo.cargoItemList[_this22.matter_index].quantity = _this22.proposalItemCargoDto_obj.quantity; // 当录入时单价总价自动转换为千分位

            _this22.ruleForm.productCargo.cargoItemList[_this22.matter_index].totalAmount = _this22.proposalItemCargoDto_obj.totalAmount;
            _this22.ruleForm.productCargo.cargoItemList[_this22.matter_index].unitAmount = _this22.proposalItemCargoDto_obj.unitAmount;
            _this22.ruleForm.productCargo.cargoItemList[_this22.matter_index].unit = _this22.proposalItemCargoDto_obj.unit;
            _this22.ruleForm.productCargo.cargoItemList[_this22.matter_index].unitName = _this22.proposalItemCargoDto_obj.unitName;
            _this22.ruleForm.productCargo.cargoItemList[_this22.matter_index].itemType = _this22.proposalItemCargoDto_obj.itemType;
            _this22.ruleForm.productCargo.cargoItemList[_this22.matter_index].itemTypeName = _this22.proposalItemCargoDto_obj.itemTypeName; // 标的类型显示名称，不往后端传递

            _this22.ruleForm.productCargo.cargoItemList[_this22.matter_index].itemCode = _this22.proposalItemCargoDto_obj.itemCode;
            console.log(_this22.ruleForm.productCargo.cargoItemList);
          } else {
            var length = _this22.ruleForm.productCargo.cargoItemList.length;
            _this22.proposalItemCargoDto_obj.serialNo = length + 1;
            _this22.proposalItemCargoDto_obj.totalAmount = _this22.proposalItemCargoDto_obj.totalAmount;
            _this22.proposalItemCargoDto_obj.unitAmount = _this22.proposalItemCargoDto_obj.unitAmount;
            _this22.proposalItemCargoDto_obj.quantity = _this22.proposalItemCargoDto_obj.quantity;

            _this22.ruleForm.productCargo.cargoItemList.push(_this22.proposalItemCargoDto_obj);
          }

          _this22.proposalItemCargoDto_obj = {
            itemCode: '',
            itemType: '',
            itemTypeName: '',
            cargoCodeName: '',
            cargoName: '',
            cargoEnName: '',
            quantity: '',
            isNewOrOld: '',
            unit: '',
            unitAmount: '0.00',
            totalAmount: '0.00'
          };

          _this22.$nextTick(function () {
            _this22.$refs['proposalItemCargoDto_obj'].clearValidate();
          });

          _this22.invoicAmountsum_fun();
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    getProvinceCityData: function getProvinceCityData() {
      var _this23 = this;

      // 获取省市区数据
      getProvinceCityArea().then(function (res) {
        _this23.provinceList = [];
        _this23.allAddressData = res;

        for (var i = 0; i < res.length; i++) {
          if (res[i].codeType == 'insuredProvince') {
            var obj = {};
            obj.codeCode = res[i].codeCode;
            obj.codeCname = res[i].codeCname;

            _this23.provinceList.push(obj);
          }
        }
      });
    },
    provinceChange: function provinceChange(val) {
      this.flag = true;
      var provinceArr = [];
      provinceArr = val.split('-');
      this.ruleForm.productFpap.provinceCode = provinceArr[0];
      this.ruleForm.productFpap.provinceName = provinceArr[1];
      this.ruleForm.productFpap.cityCode = '';
      this.ruleForm.productFpap.cityName = '';
      this.ruleForm.productFpap.areaCode = '';
      this.ruleForm.productFpap.areaName = '';
      this.cityList = [];

      for (var i = 0; i < this.allAddressData.length; i++) {
        if (this.allAddressData[i].codeCode == provinceArr[0]) {
          for (var j = 0; j < this.allAddressData[i].children.length; j++) {
            var obj = {};
            obj.codeCode = this.allAddressData[i].children[j].codeCode;
            obj.codeCname = this.allAddressData[i].children[j].codeCname;
            this.cityList.push(obj);
          }
        }
      }
    },
    cityChange: function cityChange(val) {
      this.flag = true;
      this.ruleForm.productFpap.cityCode = val;
      this.areaList = [];
      var cityArr = [];
      cityArr = val.split('-');
      this.ruleForm.productFpap.cityCode = cityArr[0];
      this.ruleForm.productFpap.cityName = cityArr[1];
      this.ruleForm.productFpap.areaCode = '';
      this.ruleForm.productFpap.areaName = '';

      for (var i = 0; i < this.allAddressData.length; i++) {
        if (this.allAddressData[i].codeCode == this.ruleForm.productFpap.provinceCode) {
          for (var j = 0; j < this.allAddressData[i].children.length; j++) {
            if (this.allAddressData[i].children[j].codeCode == cityArr[0]) {
              for (var k = 0; k < this.allAddressData[i].children[j].children.length; k++) {
                var obj = {};
                obj.codeCode = this.allAddressData[i].children[j].children[k].codeCode;
                obj.codeCname = this.allAddressData[i].children[j].children[k].codeCname;
                this.areaList.push(obj);
              }
            }
          }
        }
      }
    },
    areaChange: function areaChange(val) {
      this.ruleForm.productFpap.areaCode = val;
      var areaArr = [];
      areaArr = val.split('-');
      this.ruleForm.productFpap.areaCode = areaArr[0];
      this.ruleForm.productFpap.areaName = areaArr[1];
    },
    detailAddressCheck: function detailAddressCheck(val) {
      console.log(1234);
      var temp = 0;
      var reg = /[\s\S]/g;
      var resultn = val.match(reg);

      for (var i = 0; i < resultn.length; i++) {
        if (/[\u4e00-\u9fa5]/.test(resultn[i])) {
          temp += 3;
        } else {
          temp += 3;
        }

        if (temp > 250) {
          this.$message({
            message: '详细地址最多支持输入250个字符(约82个汉字)',
            type: 'warning'
          });
          this.ruleForm.productFpap.detailAddress = val.substring(0, i);
          break;
        }
      }
    },
    validCheckForm: function validCheckForm(insureIntent) {
      // 校验规则
      // 校验基本信息  及选中的投保意向里的产品信息
      // 基本信息                              basicInfo
      // 1、临港产品-团体人身意外伤害保险表          AGAP    productAgap
      // 2、临港产品-产品责任保险表                 LPRL    productLprl
      // 3、临港产品-关税保证保险表                 CSBP    productCsbp
      // 4、货运险 临港产品-货运险运输信息表        CARGO   productCargo
      // 5、临港产品-财产一切险表                    FPAP   productFpap
      // 6、安全生产责任保险                        SPDP    productSpdp
      // 7、贸易信用保险                            TCRP    productTcrp
      debugger; // 根据选中的投保意向去校验对应的产品的数据，没有选中的不校验

      var agapValid = false;
      var lprlValid = false;
      var csbpValid = false;
      var cargoValid = false;
      var fpapValid = false;
      var spdpValid = false;
      var tcrpValid = false;
      console.log(this.ruleForm.productAgap);

      if (insureIntent.indexOf('1') > -1) {
        this.$refs['ruleForm.productAgap'].validate(function (valid) {
          if (valid) {
            agapValid = true;
          } else {
            agapValid = false;
          }
        });
      } else {
        agapValid = true;
      }

      if (insureIntent.indexOf('2') > -1) {
        this.$refs['ruleForm.productLprl'].validate(function (valid) {
          if (valid) {
            lprlValid = true;
          } else {
            lprlValid = false;
          }
        });
      } else {
        lprlValid = true;
      }

      if (insureIntent.indexOf('3') > -1) {
        this.$refs['ruleForm.productCsbp'].validate(function (valid) {
          if (valid) {
            csbpValid = true;
          } else {
            csbpValid = false;
          }
        });
      } else {
        csbpValid = true;
      }

      if (insureIntent.indexOf('4') > -1) {
        this.$refs['ruleForm.productCargo'].validate(function (valid) {
          if (valid) {
            cargoValid = true;
          } else {
            cargoValid = false;
          }
        });
      } else {
        cargoValid = true;
      }

      if (insureIntent.indexOf('5') > -1) {
        this.$refs['ruleForm.productFpap'].validate(function (valid) {
          if (valid) {
            fpapValid = true;
          } else {
            fpapValid = false;
          }
        });
      } else {
        fpapValid = true;
      }

      if (insureIntent.indexOf('6') > -1) {
        this.$refs['ruleForm.productSpdp'].validate(function (valid) {
          if (valid) {
            spdpValid = true;
          } else {
            spdpValid = false;
          }
        });
      } else {
        spdpValid = true;
      }

      if (insureIntent.indexOf('7') > -1) {
        this.$refs['ruleForm.productTcrp'].validate(function (valid) {
          if (valid) {
            tcrpValid = true;
          } else {
            tcrpValid = false;
          }
        });
      } else {
        tcrpValid = true;
      }

      return agapValid && lprlValid && csbpValid && cargoValid && fpapValid && spdpValid && tcrpValid;
    },
    // 标的-----发票金额计算
    invoicAmountsum_fun: function invoicAmountsum_fun() {
      var sum = 0;

      for (var k = 0; k < this.ruleForm.productCargo.cargoItemList.length; k++) {
        if (this.this.ruleForm.productCargo.cargoItemList[k].totalAmount != null) {
          if (typeof this.ruleForm.productCargo.cargoItemList[k].totalAmount === 'string') {
            var numtotalAmount = parseFloat(this.ruleForm.productCargo.cargoItemList[k].totalAmount.replace(/,/g, '')); // console.log(numtotalAmount,'*****------')
          } else {
            var numtotalAmount = this.ruleForm.productCargo.cargoItemList[k].totalAmount;
          }

          sum = accAdd(sum, numtotalAmount);
        }
      }
    },
    // 自定义标的类型
    itemType_ch2: function itemType_ch2(val) {
      for (var i = 0; i < this.itemType_option.length; i++) {
        if (val == this.itemType_option[i].value) {
          this.proposalItemCargoDto_obj.itemTypeName = this.itemType_option[i].label;
        }
      }
    },
    // 单位
    unit_fun: function unit_fun(val) {
      this.proposalItemCargoDto_obj.unitName = this.list_select(val, this.measuringUnit_option);
    },
    //运输方式
    conveyanceWayCode_ch: function conveyanceWayCode_ch(val) {
      if (val == null || val == "") {
        this.text4.conveyanceWayCode = "请输入运输方式";
      } else {
        this.text4.conveyanceWayCode = "";
      }

      this.ruleForm.productCargo.productCargoConveyItem.conveyanceWayName = this.list_select(val, this.conveyance_option);
    },
    changeDateStart: function changeDateStart(value) {
      var currentDate = this.getCurrentTime(); // 当前日期时间戳

      currentDate = this.getTimes(currentDate);
      var startTime = this.getTimes(value);

      if (startTime < currentDate) {
        this.$message.warning('选择日期应不小于当前日期');
      } else {
        var endTime = this.getEndDate(value, '1年');
        this.formData.insureRange.expectEndDate = endTime;
      }
    },
    changeDateEnd: function changeDateEnd(value) {
      var startTime = this.getTimes(this.formData.insureRange.expectStartDate);
      var endTime = this.getTimes(value);

      if (endTime < startTime) {
        this.$message.warning('选择日期应不小于保险期限起期');
      }
    },
    // 获取时间戳
    getTimes: function getTimes(time) {
      var date = time;
      date = date.substring(0, 19);
      date = date.replace(/-/g, "/"); //必须把日期'-'转为'/'

      var timestamp = new Date(date).getTime();
      return timestamp;
    },
    // 获取当前日期
    getCurrentTime: function getCurrentTime() {
      var date = new Date();
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var day = date.getDate();

      if (month < 10) {
        month = "0" + month;
      }

      if (day < 10) {
        day = "0" + day;
      }

      var nowDate = year + "-" + month + "-" + day;
      return nowDate;
    },
    getEndDate: function getEndDate(start, section) {
      var end = '';
      var startDate = new Date(start);

      if (section.indexOf('年')) {
        var sec = section.replace('年', '') - 0;
        startDate.setFullYear(startDate.getFullYear() + sec);
      } else if (section.indexOf('月')) {
        var _sec = section.replace('月', '') - 0;

        startDate.setMonth(startDate.getMonth() + _sec);
      } else {
        var _sec2 = section.replace('天', '') - 0;

        startDate.setDate(startDate.getDate() + _sec2);
      }

      startDate.setDate(startDate.getDate() - 1);
      end = this.dateFomat(startDate);
      return end;
    },
    dateFomat: function dateFomat(date) {
      var division = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '-';
      return date.getFullYear() + division + this.supplementZero(date.getMonth() + 1) + division + this.supplementZero(date.getDate());
    }
  }
};